/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isObject = isObject;
exports.isNumber = isNumber;
exports.isPositiveNumber = isPositiveNumber;
exports.isInt = isInt;
exports.isPositiveInt = isPositiveInt;
exports.isString = isString;
exports.isNonEmptyString = isNonEmptyString;
exports.arePositiveNumbers = arePositiveNumbers;
exports.round = round;
exports.sameAbs = sameAbs;
exports.randomFloat = randomFloat;
exports.normalizeAngle = normalizeAngle;
exports.radToDeg = radToDeg;
exports.distanceToDuration = distanceToDuration;
exports.log = log;
exports.logWarning = logWarning;
exports.logError = logError;
exports.byID = byID;
exports.isHTMLElement = isHTMLElement;
exports.flush = flush;
exports.forfor = forfor;
exports.anyKeyBeingPressed = anyKeyBeingPressed;
exports.anyMouseButtonBeingPressed = anyMouseButtonBeingPressed;
exports.anyInputBeingPressed = anyInputBeingPressed;
exports.isMouseButton = isMouseButton;
exports.isKeyList = isKeyList;
exports.isFKey = isFKey;
var typeOf = function (global) {
    return function (obj) {
        if (obj === global) {
            return "global";
        }
        return {}.toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
    };
}(undefined);

var CONSOLE_PREFIX = "[Zatacka] ";

var KEY = exports.KEY = Object.freeze({ BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, PAUSE: 19, CAPS_LOCK: 20, ESCAPE: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT_ARROW: 37, UP_ARROW: 38, RIGHT_ARROW: 39, DOWN_ARROW: 40, INSERT: 45, DELETE: 46, "0": 48, "1": 49, "2": 50, "3": 51, "4": 52, "5": 53, "6": 54, "7": 55, "8": 56, "9": 57, A: 65, B: 66, C: 67, D: 68, E: 69, F: 70, G: 71, H: 72, I: 73, J: 74, K: 75, L: 76, M: 77, N: 78, O: 79, P: 80, Q: 81, R: 82, S: 83, T: 84, U: 85, V: 86, W: 87, X: 88, Y: 89, Z: 90, LEFT_META: 91, RIGHT_META: 92, SELECT: 93, NUMPAD_0: 96, NUMPAD_1: 97, NUMPAD_2: 98, NUMPAD_3: 99, NUMPAD_4: 100, NUMPAD_5: 101, NUMPAD_6: 102, NUMPAD_7: 103, NUMPAD_8: 104, NUMPAD_9: 105, MULTIPLY: 106, ADD: 107, SUBTRACT: 109, DECIMAL: 110, DIVIDE: 111, F1: 112, F2: 113, F3: 114, F4: 115, F5: 116, F6: 117, F7: 118, F8: 119, F9: 120, F10: 121, F11: 122, F12: 123, NUM_LOCK: 144, SCROLL_LOCK: 145, SEMICOLON: 186, EQUALS: 187, COMMA: 188, DASH: 189, PERIOD: 190, FORWARD_SLASH: 191, GRAVE_ACCENT: 192, OPEN_BRACKET: 219, BACK_SLASH: 220, CLOSE_BRACKET: 221, SINGLE_QUOTE: 222 });

var MOUSE = exports.MOUSE = Object.freeze(function () {
    var offset = 1000;
    return Object.freeze({
        unpack: function unpack(offseted) {
            return offseted - offset;
        },
        pack: function pack(standard) {
            return standard + offset;
        },
        LEFT: offset + 0,
        RIGHT: offset + 2,
        MIDDLE: offset + 1,
        MOUSE4: offset + 3,
        MOUSE5: offset + 4
    });
}());

var F_KEYS = exports.F_KEYS = Object.freeze([KEY.F1, KEY.F2, KEY.F3, KEY.F4, KEY.F5, KEY.F6, KEY.F7, KEY.F8, KEY.F9, KEY.F10, KEY.F11, KEY.F12]);

var MOUSE_BUTTONS = exports.MOUSE_BUTTONS = Object.freeze([MOUSE.LEFT, MOUSE.RIGHT, MOUSE.MIDDLE, MOUSE.MOUSE4, MOUSE.MOUSE5]);

function isObject(obj) {
    return typeOf(obj) === "object";
}

function isNumber(n) {
    return typeOf(n) === "number";
}

function isPositiveNumber(n) {
    return isNumber(n) && n > 0;
}

function isInt(n) {
    return isNumber(n) && n % 1 === 0;
}

function isPositiveInt(n) {
    return isInt(n) && n > 0;
}

function isString(s) {
    return typeOf(s) === "string";
}

function isNonEmptyString(s) {
    return isString(s) && s.length > 0;
}

function arePositiveNumbers(numbers) {
    return numbers.every(isPositiveNumber);
}

function round(number, decimals) {
    return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

function sameAbs(a, b) {
    return Math.abs(a) === Math.abs(b);
}

/**
 * Generates a random float between min (inclusive) and max (exclusive).
 *
 * @param {Number} min
 *   Minimum value (inclusive).
 * @param {Number} max
 *   Maximum value (exclusive).
 */
function randomFloat(min, max) {
    return Math.random() * (max - min) + min;
}

function normalizeAngle(a) {
    var pi = Math.PI;
    var angle = a % (2 * pi);
    angle = (angle + 2 * pi) % (2 * pi);
    if (angle > pi) {
        angle = angle - 2 * pi;
    }
    return angle;
}

function radToDeg(radians) {
    return 180 / Math.PI * radians;
}

function distanceToDuration(distance, velocity) {
    return distance / velocity * 1000; // milliseconds
}

function log(str) {
    console.log(CONSOLE_PREFIX + str);
}

function logWarning(str) {
    console.warn(CONSOLE_PREFIX + str);
}

function logError(str) {
    console.error(CONSOLE_PREFIX + str);
}

function byID(id) {
    return document.getElementById(id);
}

function isHTMLElement(elem) {
    return elem instanceof HTMLElement;
}

function flush(node) {
    if (isHTMLElement(node)) {
        node.textContent = "";
    } else {
        throw new TypeError(node + " is not a DOM node.");
    }
}

function forfor(y_start, y_end, x_start, x_end, func, arg) {
    for (var y = y_start; y < y_end; y++) {
        for (var x = x_start; x < x_end; x++) {
            func.call(this, x, y, arg);
        }
    }
}

var Keyboard = exports.Keyboard = {
    pressed: {},
    isDown: function isDown(keyCode) {
        return !!this.pressed[keyCode];
    },
    onKeydown: function onKeydown(event) {
        this.pressed[event.keyCode] = true;
    },
    onKeyup: function onKeyup(event) {
        delete this.pressed[event.keyCode];
    },
    reset: function reset() {
        this.pressed = {};
    }
};

var Mouse = exports.Mouse = {
    pressed: {},
    isDown: function isDown(mouseButtonNumber) {
        return this.pressed[mouseButtonNumber];
    },
    onMousedown: function onMousedown(event) {
        this.pressed[event.button] = true;
    },
    onMouseup: function onMouseup(event) {
        delete this.pressed[event.button];
    },
    reset: function reset() {
        this.pressed = {};
    }
};

function anyKeyBeingPressed(keyCodes) {
    return Array.isArray(keyCodes) && keyCodes.some(Keyboard.isDown, Keyboard);
}

function anyMouseButtonBeingPressed(mouseButtons) {
    return Array.isArray(mouseButtons) && mouseButtons.map(MOUSE.unpack).some(Mouse.isDown, Mouse);
}

function anyInputBeingPressed(keysOrMouseButtons) {
    return anyKeyBeingPressed(keysOrMouseButtons) || anyMouseButtonBeingPressed(keysOrMouseButtons);
}

function isMouseButton(button) {
    return isPositiveInt(button) && Object.keys(MOUSE).some(function (buttonName) {
        return MOUSE.hasOwnProperty(buttonName);
    });
}

function isKeyList(keys) {
    return Array.isArray(keys) && keys.length > 0 && keys.every(isPositiveInt);
}

function isFKey(key) {
    return F_KEYS.includes(key);
}

var PLATFORM = exports.PLATFORM = function () {
    var strings = {
        os_id_windows: "Win",
        os_id_mac: "Mac",
        os_id_linux: "Linux",
        os_id_unix: "X11",

        os_name_windows: "Windows",
        os_name_mac: "Mac",
        os_name_linux: "Linux",
        os_name_unix: "UNIX",
        os_name_unknown: "Unknown"
    };

    return {
        getOS: function getOS() {
            var ua = window.navigator.userAgent || window.navigator.appVersion;
            if (isNonEmptyString(ua)) {
                if (ua.indexOf(strings.os_id_windows) > -1) {
                    return strings.os_name_windows;
                }
                if (ua.indexOf(strings.os_id_mac) > -1) {
                    return strings.os_name_mac;
                }
                if (ua.indexOf(strings.os_id_linux) > -1) {
                    return strings.os_name_linux;
                }
                if (ua.indexOf(strings.os_id_unix) > -1) {
                    return strings.os_name_unix;
                }
            }
            return strings.os_name_unknown;
        },
        getFullscreenShortcut: function getFullscreenShortcut() {
            switch (PLATFORM.getOS()) {
                case strings.os_name_mac:
                    return "mac";
                    break;
                default:
                    return "default";
            }
        }
    };
}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

exports.default = function () {
        var KEY_SHIFT = "⇧";
        var KEY_CMD = "⌘";
        var KEY_PROCEED = "Space or Enter";
        var KEY_QUIT = "Esc";

        return Object.freeze({
                hint_start: "Press <kbd>Space</kbd> to start",
                hint_popup: "It is recommended to run Kurve in its own window without history (to avoid switching tabs or navigating back in history mid-game). Click here to do so.",
                hint_pick: "Pick your desired color by pressing the corresponding LEFT key (e.g. M for Orange).",
                hint_proceed: "Press " + KEY_PROCEED + " to start!",
                hint_next: "Press " + KEY_PROCEED + " to proceed, or " + KEY_QUIT + " to quit.",
                hint_quit: "Press " + KEY_PROCEED + " to start over.",
                hint_alt: "Alt plus some other keys may cause undesired behavior (e.g. switching windows).",
                hint_ctrl: "Ctrl plus some other keys may cause undesired behavior (e.g. closing the tab).",
                hint_mouse: "Make sure to keep the mouse cursor inside the browser window.",
                hint_preferences_access_denied: "Could not save/load settings because access to localStorage was denied by the browser. This might be caused by \"third-party site data\" being blocked or similar.",

                keyboard_fullscreen_mac: "<kbd>" + KEY_CMD + " + Ctrl + F</kbd> and/or <kbd>" + KEY_CMD + " + " + KEY_SHIFT + " + F</kbd>",
                keyboard_fullscreen_standard: "<kbd>F11</kbd>",

                getFullscreenHint: function getFullscreenHint(shortcut) {
                        return "Press " + shortcut + " to toggle fullscreen";
                },

                label_button_alert_ok: "OK",
                label_button_confirm_yes: "Yes",
                label_button_confirm_no: "No",

                label_text_confirm_quit: "Are you sure you want to quit?",
                label_text_confirm_reload: "Are you sure you want to reload the application?",

                pref_label_cursor: "Mouse pointer",
                pref_label_description_cursor: "Control how the pointer behaves when the game is live. (It is always visible in the menu.) \"Used by player\" means that a player is using the mouse to control their Kurve.",
                pref_label_cursor_always_visible: "Always visible",
                pref_label_cursor_hidden_when_mouse_used_by_player: "Hidden when mouse used by player",
                pref_label_cursor_always_hidden: "Always hidden",

                pref_label_edge_fix: "Invisible border fix",
                pref_label_description_edge_fix: "Shrink the playing field slightly to make the gray border visible if the monitor is exactly the same height and/or width as the game (in pixels).",
                pref_label_edge_fix_off: "Off",
                pref_label_edge_fix_minimal: "Minimal",
                pref_label_edge_fix_full: "Full",

                pref_label_hints: "Messages",
                pref_label_description_hints: "Hints (white text) are unnecessary for experienced Kurve players. Warnings (yellow) can be useful for players new to playing Kurve in the browser.",
                pref_label_hints_all: "Hints and warnings",
                pref_label_hints_warnings_only: "Warnings only",
                pref_label_hints_none: "None",

                pref_label_prevent_spawnkill: "Prevent spawnkills",
                pref_label_description_prevent_spawnkill: "Enforce a minimum distance between players at round start.",

                pref_label_confirm_quit: "Confirm quit",
                pref_label_description_confirm_quit: "Ask for confirmation before quitting to the main menu (Esc) or reloading the application (F5).",

                pref_label_scaling: "Scaling",
                pref_label_description_scaling: "Visual quality ensures a crisp, pixelmapped image. On-screen size may result in blurry graphics and other visual errors, but can be useful if the game is very small on your screen.",
                pref_label_scaling_prefer_quality: "Prefer visual quality",
                pref_label_scaling_prefer_size: "Prefer on-screen size"
        });
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Object.freeze({
    game_url: "ZATACKA.html",

    error_name_security: "SecurityError",

    class_hidden: "hidden",
    class_active: "active",
    class_dialog: "dialog",
    class_dialog_alert: "alert",
    class_dialog_confirmation: "confirmation",
    class_description: "description",
    class_half_width: "half-width",
    class_right_hand_side: "right-hand-side",
    class_blurry: "blurry",
    class_nocursor: "nocursor",
    class_tempcursor: "tempcursor",
    class_hints_warnings_only: "hints-warnings-only",
    class_hints_none: "hints-none",
    html_name_preference_prefix: "preference-",

    cursor_hidden: "hidden",
    cursor_visible: "visible",

    id_start_hint: "start-hint",
    id_fullscreen_hint: "fullscreen-hint",
    id_button_show_settings: "button-show-settings",
    id_button_hide_settings: "button-hide-settings",

    pref_number_type_integer: "integer",
    pref_number_type_float: "float",

    pref_key_cursor: "cursor",
    pref_value_cursor_always_visible: "always_visible",
    pref_value_cursor_hidden_when_mouse_used_by_player: "hidden_when_mouse_used_by_player",
    pref_value_cursor_always_hidden: "always_hidden",

    pref_key_edge_fix: "edge_fix",
    pref_value_edge_fix_full: "full",
    pref_value_edge_fix_minimal: "minimal",
    pref_value_edge_fix_off: "off",

    pref_key_hints: "hints",
    pref_value_hints_all: "all",
    pref_value_hints_warnings_only: "warnings",
    pref_value_hints_none: "none",

    pref_key_confirm_quit: "confirm_quit",
    pref_key_confirm_reload: "confirm_reload",
    pref_key_prevent_spawnkill: "prevent_spawnkill",

    pref_key_scaling: "scaling",
    pref_value_scaling_prefer_quality: "prefer_quality",
    pref_value_scaling_prefer_size: "prefer_size"
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Preference = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PreferencesUtilities = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Preference = exports.Preference = function () {
    function Preference(data) {
        _classCallCheck(this, Preference);

        if (!(0, _PreferencesUtilities.isString)(data.key)) {
            throw new TypeError("key must be a string (found " + data.key + "). More info: " + data);
        } else if (data.default === undefined) {
            throw new TypeError("Preference '" + data.key + "' must have a default value.");
        } else if (data.label === undefined) {
            throw new TypeError("Preference '" + data.key + "' must have a label.");
        } else if (data.description === undefined) {
            throw new TypeError("Preference '" + data.key + "' must have a description.");
        }
        this.key = data.key;
        this.label = data.label;
        this.default = data.default;
        this.description = data.description;
    }

    _createClass(Preference, [{
        key: "isValidValue",
        value: function isValidValue(value) {
            return (0, _PreferencesUtilities.isString)(value);
        }
    }, {
        key: "invalidValue",
        value: function invalidValue(value) {
            throw new TypeError(value + " is not a valid value for preference '" + this.key + "'.");
        }
    }, {
        key: "getDefaultValue",
        value: function getDefaultValue() {
            return this.default;
        }
    }], [{
        key: "stringify",
        value: function stringify(value) {
            return value.toString();
        }
    }, {
        key: "parse",
        value: function parse(stringifiedValue) {
            return stringifiedValue;
        }
    }]);

    return Preference;
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
exports.logWarning = logWarning;
exports.logError = logError;
exports.isObject = isObject;
exports.isNumber = isNumber;
exports.isPositiveNumber = isPositiveNumber;
exports.isInt = isInt;
exports.isPositiveInt = isPositiveInt;
exports.isString = isString;
exports.isNonEmptyString = isNonEmptyString;
exports.arePositiveNumbers = arePositiveNumbers;
exports.round = round;
var typeOf = function (global) {
    return function (obj) {
        if (obj === global) {
            return "global";
        }
        return {}.toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
    };
}(undefined);

var CONSOLE_PREFIX = "[Preferences] ";

function log(string) {
    console.log(CONSOLE_PREFIX + string);
}

function logWarning(string) {
    console.warn(CONSOLE_PREFIX + string);
}

function logError(string) {
    console.error(CONSOLE_PREFIX + string);
}

function isObject(obj) {
    return typeOf(obj) === "object";
}

function isNumber(n) {
    return typeOf(n) === "number";
}

function isPositiveNumber(n) {
    return isNumber(n) && n > 0;
}

function isInt(n) {
    return isNumber(n) && n % 1 === 0;
}

function isPositiveInt(n) {
    return isInt(n) && n > 0;
}

function isString(s) {
    return typeOf(s) === "string";
}

function isNonEmptyString(s) {
    return isString(s) && s.length > 0;
}

function arePositiveNumbers(numbers) {
    return numbers.every(isPositiveNumber);
}

function round(number, decimals) {
    return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Player = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utilities = __webpack_require__(0);

var _Queue = __webpack_require__(22);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Player = exports.Player = function () {
    function Player(id) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Player " + id;
        var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "white";
        var L_keys = arguments[3];
        var R_keys = arguments[4];
        var holeConfig = arguments[5];

        _classCallCheck(this, Player);

        if (!(0, _utilities.isPositiveInt)(id)) {
            throw new TypeError("Cannot create a player with ID " + id + ". Only positive integers are accepted.");
        }
        this.id = id;
        this.name = name;
        this.color = color;
        this.alive = false;
        this.holy = false;
        this.x = null;
        this.y = null;
        this.direction = 0;
        this.velocity = 0;
        this.maxSpeed = undefined;
        this.lastPosition = null;
        this.queuedDraws = new _Queue.Queue();
        this.holeTimer = null;
        this.holeConfig = null;

        if (!this.constructor.isHoleConfig(holeConfig)) {
            (0, _utilities.logWarning)("Creating player " + this.name + " with no hole configuration because " + holeConfig + " is not a valid hole configuration.");
        } else {
            this.holeConfig = holeConfig;
        }

        if ((0, _utilities.isPositiveInt)(L_keys)) {
            this.L_keys = [L_keys];
        } else if ((0, _utilities.isKeyList)(L_keys)) {
            this.L_keys = L_keys;
        } else {
            (0, _utilities.logWarning)("Creating player \"" + this.name + "\" without any LEFT key(s).");
            this.L_keys = [];
        }

        if ((0, _utilities.isPositiveInt)(R_keys)) {
            this.R_keys = [R_keys];
        } else if ((0, _utilities.isKeyList)(R_keys)) {
            this.R_keys = R_keys;
        } else {
            (0, _utilities.logWarning)("Creating player \"" + this.name + "\" without any RIGHT key(s).");
            this.R_keys = [];
        }
    }

    _createClass(Player, [{
        key: "isAlive",


        // CHECKERS

        value: function isAlive() {
            return this.alive;
        }
    }, {
        key: "justWasAt",
        value: function justWasAt(left, top) {
            return this.lastPosition.left === left && this.lastPosition.top === top;
        }
    }, {
        key: "isHoly",
        value: function isHoly() {
            return this.holy;
        }
    }, {
        key: "isPressingLeft",
        value: function isPressingLeft() {
            return (0, _utilities.anyInputBeingPressed)(this.L_keys);
        }
    }, {
        key: "isPressingRight",
        value: function isPressingRight() {
            return (0, _utilities.anyInputBeingPressed)(this.R_keys);
        }
    }, {
        key: "hasID",
        value: function hasID(id) {
            return this.id === id;
        }
    }, {
        key: "hasMouseButton",
        value: function hasMouseButton(button) {
            return (0, _utilities.isMouseButton)(button) && (this.L_keys.includes(button) || this.R_keys.includes(button));
        }
    }, {
        key: "usesAnyMouseButton",
        value: function usesAnyMouseButton() {
            var _this = this;

            return _utilities.MOUSE_BUTTONS.some(function (button) {
                return _this.hasMouseButton(button);
            });
        }
    }, {
        key: "hasKey",
        value: function hasKey(key) {
            return this.L_keys.includes(key) || this.R_keys.includes(key);
        }

        // GETTERS

    }, {
        key: "getID",
        value: function getID() {
            return this.id;
        }
    }, {
        key: "getName",
        value: function getName() {
            return this.name;
        }
    }, {
        key: "getColor",
        value: function getColor() {
            return this.color;
        }
    }, {
        key: "toString",
        value: function toString() {
            return this.name;
        }
    }, {
        key: "getLastPosition",
        value: function getLastPosition() {
            return this.lastPosition;
        }
    }, {
        key: "getVelocity",
        value: function getVelocity() {
            return this.velocity;
        }
    }, {
        key: "getDirection",
        value: function getDirection() {
            return this.direction;
        }
    }, {
        key: "randomPaddedHoleSize",
        value: function randomPaddedHoleSize() {
            return (0, _utilities.randomFloat)(this.holeConfig.minPaddedHoleSize, this.holeConfig.maxPaddedHoleSize);
        }
    }, {
        key: "randomPaddedHoleInterval",
        value: function randomPaddedHoleInterval() {
            return (0, _utilities.randomFloat)(this.holeConfig.minPaddedHoleInterval, this.holeConfig.maxPaddedHoleInterval);
        }
    }, {
        key: "firstHoleDelay",
        value: function firstHoleDelay() {
            return (0, _utilities.distanceToDuration)(this.randomPaddedHoleInterval() - this.holeConfig.minPaddedHoleInterval, this.velocity);
        }

        // SETTERS

    }, {
        key: "setMaxSpeed",
        value: function setMaxSpeed(speed) {
            this.maxSpeed = speed;
        }
    }, {
        key: "setDirection",
        value: function setDirection(direction) {
            this.direction = direction;
        }

        // DOERS

    }, {
        key: "start",
        value: function start() {
            (0, _utilities.log)(this + " starting.");
            this.alive = true;
            this.velocity = this.maxSpeed;
            if (this.constructor.isHoleConfig(this.holeConfig)) {
                this.holeTimer = setTimeout(this.startCreatingHoles.bind(this), this.firstHoleDelay());
            }
        }
    }, {
        key: "stop",
        value: function stop() {
            this.alive = false;
            this.velocity = 0;
            clearTimeout(this.holeTimer);
        }
    }, {
        key: "reset",
        value: function reset() {
            this.holy = false;
            this.lastPosition = null;
            this.queuedDraws = new _Queue.Queue();
        }

        /**
         * Called when the player does something that causes it do die.
         * @param {String} cause The cause of death.
         */

    }, {
        key: "die",
        value: function die(cause) {
            this.alive = false;
            clearTimeout(this.holeTimer);
            (0, _utilities.log)(this + " " + (cause || "died") + " at (" + (0, _utilities.round)(this.x, 2) + ", " + (0, _utilities.round)(this.y, 2) + ").");
        }
    }, {
        key: "beAt",
        value: function beAt(left, top) {
            this.lastPosition = {
                "left": left,
                "top": top
            };
        }
    }, {
        key: "beginHole",
        value: function beginHole() {
            this.holy = true;
            var paddedHoleSize = this.randomPaddedHoleSize();
            var paddedHoleDuration = (0, _utilities.distanceToDuration)(paddedHoleSize, this.velocity);
            this.holeTimer = setTimeout(this.endHole.bind(this), paddedHoleDuration);
        }
    }, {
        key: "endHole",
        value: function endHole() {
            this.holy = false;
            var paddedHoleInterval = this.randomPaddedHoleInterval();
            var paddedHoleIntervalDuration = (0, _utilities.distanceToDuration)(paddedHoleInterval, this.velocity);
            this.holeTimer = setTimeout(this.beginHole.bind(this), paddedHoleIntervalDuration);
        }
    }, {
        key: "startCreatingHoles",
        value: function startCreatingHoles() {
            this.beginHole();
        }
    }, {
        key: "enqueueDraw",
        value: function enqueueDraw() {
            this.queuedDraws.enqueue({ "x": this.x, "y": this.y });
        }
    }], [{
        key: "isPlayer",
        value: function isPlayer(player) {
            return player instanceof Player;
        }
    }, {
        key: "isHoleConfig",
        value: function isHoleConfig(holeConfig) {
            return (0, _utilities.isObject)(holeConfig) && (0, _utilities.arePositiveNumbers)([holeConfig.minPaddedHoleSize, holeConfig.maxPaddedHoleSize, holeConfig.minPaddedHoleInterval, holeConfig.maxPaddedHoleInterval]);
        }
    }]);

    return Player;
}();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConfirmationDialog = undefined;

var _Dialog2 = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmationDialog = exports.ConfirmationDialog = function (_Dialog) {
    _inherits(ConfirmationDialog, _Dialog);

    function ConfirmationDialog(question, callback) {
        _classCallCheck(this, ConfirmationDialog);

        if (!(callback instanceof Function)) {
            throw new TypeError("callback must be a function (found " + callback + ").");
        }

        var _this = _possibleConstructorReturn(this, (ConfirmationDialog.__proto__ || Object.getPrototypeOf(ConfirmationDialog)).call(this, question));

        _this.callback = callback;
        return _this;
    }

    return ConfirmationDialog;
}(_Dialog2.Dialog);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Dialog = undefined;

var _utilities = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dialog = exports.Dialog = function Dialog(text) {
    _classCallCheck(this, Dialog);

    if (!(0, _utilities.isString)(text)) {
        throw new TypeError("text must be a string (found " + text + ").");
    }
    this.text = text;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Message = exports.Message = function () {
    function Message(text, styleClass) {
        _classCallCheck(this, Message);

        this.text = text;
        this.class = styleClass;
    }

    _createClass(Message, [{
        key: "toHTMLElement",
        value: function toHTMLElement() {
            var p = document.createElement("p");
            p.innerHTML = this.text;
            p.classList.add(this.class);
            p.classList.add("message");
            return p;
        }
    }]);

    return Message;
}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BooleanPreference = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Preference2 = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BooleanPreference = exports.BooleanPreference = function (_Preference) {
    _inherits(BooleanPreference, _Preference);

    function BooleanPreference(data) {
        _classCallCheck(this, BooleanPreference);

        var _this = _possibleConstructorReturn(this, (BooleanPreference.__proto__ || Object.getPrototypeOf(BooleanPreference)).call(this, data));

        if (!(data.default === true || data.default === false)) {
            _get(BooleanPreference.prototype.__proto__ || Object.getPrototypeOf(BooleanPreference.prototype), "invalidValue", _this).call(_this, data.default);
        }
        return _this;
    }

    _createClass(BooleanPreference, [{
        key: "isValidValue",
        value: function isValidValue(value) {
            return value === true || value === false;
        }
    }], [{
        key: "stringify",
        value: function stringify(value) {
            return value.toString();
        }
    }, {
        key: "parse",
        value: function parse(stringifiedValue) {
            return stringifiedValue === "true";
        }
    }]);

    return BooleanPreference;
}(_Preference2.Preference);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultichoicePreference = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Preference2 = __webpack_require__(3);

var _MultichoicePreferenceOption = __webpack_require__(25);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultichoicePreference = exports.MultichoicePreference = function (_Preference) {
    _inherits(MultichoicePreference, _Preference);

    function MultichoicePreference(data) {
        _classCallCheck(this, MultichoicePreference);

        if (!isArray(data.options)) {
            throw new TypeError("options must be an array (found " + data.options + " for preference '" + data.key + "').");
        }
        if (!hasMultipleEntries(data.options)) {
            throw new TypeError("options must have a length greater than 1 (was " + data.options.length + " for preference '" + data.key + "').");
        }

        var _this = _possibleConstructorReturn(this, (MultichoicePreference.__proto__ || Object.getPrototypeOf(MultichoicePreference)).call(this, data));

        try {
            _this.options = data.options.map(function (option) {
                return new _MultichoicePreferenceOption.MultichoicePreferenceOption(option.key, option.label);
            });
        } catch (e) {
            throw new TypeError("The list of options for preference '" + data.key + "' was malformed: " + e.message);
        }

        if (!_this.isValidValue(data.default)) {
            _get(MultichoicePreference.prototype.__proto__ || Object.getPrototypeOf(MultichoicePreference.prototype), "invalidValue", _this).call(_this, data.default);
        }

        function isArray(options) {
            return options instanceof Array;
        }

        function hasMultipleEntries(options) {
            return options.length > 1;
        }
        return _this;
    }

    _createClass(MultichoicePreference, [{
        key: "isValidValue",
        value: function isValidValue(value) {
            return this.options.some(function (option) {
                return option.key === value;
            });
        }
    }], [{
        key: "stringify",
        value: function stringify(value) {
            return value;
        }
    }, {
        key: "parse",
        value: function parse(stringifiedValue) {
            return stringifiedValue;
        }
    }]);

    return MultichoicePreference;
}(_Preference2.Preference);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RangePreference = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Preference2 = __webpack_require__(3);

var _PreferencesUtilities = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangePreference = exports.RangePreference = function (_Preference) {
    _inherits(RangePreference, _Preference);

    function RangePreference(data) {
        _classCallCheck(this, RangePreference);

        if (!(0, _PreferencesUtilities.isNumber)(data.min) || !(0, _PreferencesUtilities.isNumber)(data.max)) {
            throw new TypeError("min and max must be numbers (found " + data.min + " and " + data.max + " for preference '" + data.key + "').");
        } else if (data.min > data.max) {
            throw new TypeError("min cannot be greater than max (found " + data.min + " and " + data.max + " for preference '" + data.key + "', respectively).");
        }

        var _this = _possibleConstructorReturn(this, (RangePreference.__proto__ || Object.getPrototypeOf(RangePreference)).call(this, data));

        _this.min = data.min;
        _this.max = data.max;
        if (!_this.isValidValue(data.default)) {
            _get(RangePreference.prototype.__proto__ || Object.getPrototypeOf(RangePreference.prototype), "invalidValue", _this).call(_this, data.default);
        }
        return _this;
    }

    _createClass(RangePreference, [{
        key: "isValidValue",
        value: function isValidValue(value) {
            return (0, _PreferencesUtilities.isNumber)(value) && value >= this.min && value <= this.max;
        }
    }], [{
        key: "stringify",
        value: function stringify(value) {
            return value.toString();
        }
    }, {
        key: "parse",
        value: function parse(stringifiedValue) {
            return parseFloat(stringifiedValue);
        }
    }]);

    return RangePreference;
}(_Preference2.Preference);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GUIController = GUIController;

var _Preference = __webpack_require__(3);

var _BooleanPreference = __webpack_require__(9);

var _RangePreference = __webpack_require__(11);

var _IntegerRangePreference = __webpack_require__(24);

var _MultichoicePreference = __webpack_require__(10);

var _Dialog = __webpack_require__(7);

var _ConfirmationDialog = __webpack_require__(6);

var _utilities = __webpack_require__(0);

var _ZatackaEn_US = __webpack_require__(1);

var _ZatackaEn_US2 = _interopRequireDefault(_ZatackaEn_US);

var _strings = __webpack_require__(2);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GUIController(cfg) {

    var config = cfg;
    var lobby = (0, _utilities.byID)("lobby");
    var controls = (0, _utilities.byID)("controls");
    var canvas_main = (0, _utilities.byID)("canvas_main");
    var canvas_overlay = (0, _utilities.byID)("canvas_overlay");
    var left = (0, _utilities.byID)("left");
    var scoreboard = (0, _utilities.byID)("scoreboard");
    var results = (0, _utilities.byID)("results");
    var KONEC_HRY = (0, _utilities.byID)("KONEC_HRY");
    var messagesContainer = (0, _utilities.byID)("messages");
    // const settingsContainer = byID("settings");
    var dialogsOverlay = (0, _utilities.byID)("dialogs");
    var settingsForm = (0, _utilities.byID)("settings-form");

    var ORIGINAL_LEFT_WIDTH = left.offsetWidth;
    var MULTICHOICE_LABEL_MAX_LENGTH_FOR_HALFWIDTH_FIELDSET = 20; // More characters than this will result in a full-width div/fieldset.
    var FLOAT_RANGE_PREFERENCE_STEP = 0.01;

    var BUTTON_TAG_NAME = "button";
    var BUTTON_NODE_CLASS = HTMLButtonElement;

    var LABEL_ALERT_OK = _ZatackaEn_US2.default.label_button_alert_ok;
    var LABEL_CONFIRM_YES = _ZatackaEn_US2.default.label_button_confirm_yes;
    var LABEL_CONFIRM_NO = _ZatackaEn_US2.default.label_button_confirm_no;

    var showingSettings = false;
    var currentMessages = [];
    var queuedDialogs = [];
    var currentDialogWithBox = null;

    var DialogWithBox = function DialogWithBox(dialog, box) {
        _classCallCheck(this, DialogWithBox);

        this.dialog = dialog;
        this.box = box;
    };

    // PRIVATE FUNCTIONS

    function hideLobby() {
        (0, _utilities.log)("Hiding lobby.");
        lobby.classList.add(_strings2.default.class_hidden);
    }

    function showLobby() {
        (0, _utilities.log)("Showing lobby.");
        lobby.classList.remove(_strings2.default.class_hidden);
    }

    function showDialogsOverlay() {
        dialogsOverlay.classList.remove(_strings2.default.class_hidden);
    }

    function hideDialogsOverlay() {
        dialogsOverlay.classList.add(_strings2.default.class_hidden);
    }

    function isLobbyEntry(element) {
        return (0, _utilities.isHTMLElement)(element) && element.children.length >= 2;
    }

    function isButton(element) {
        return element instanceof BUTTON_NODE_CLASS;
    }

    function showDialogRightAway(dialog) {
        var dialogBox = dialogHTMLElement(dialog);
        currentDialogWithBox = new DialogWithBox(dialog, dialogBox);
        setTemporaryCursorVisibility(true);
        showDialogsOverlay();
        dialogsOverlay.appendChild(dialogBox);
        // A dialog should have its last button focused:
        dialogBox.querySelector("button:last-of-type").focus();
    }

    function currentDialogClosed() {
        currentDialogWithBox.box.remove();
        currentDialogWithBox = null;
        if (anyQueuedDialogs()) {
            // There is at least one dialog waiting. Show it:
            showDialogRightAway(queuedDialogs.shift());
        } else {
            // No more dialogs. Restore:
            setTemporaryCursorVisibility(false);
            hideDialogsOverlay();
        }
    }

    function anyQueuedDialogs() {
        return queuedDialogs.length > 0;
    }

    function escapeShouldCloseCurrentDialog() {
        return currentDialogWithBox.dialog instanceof _ConfirmationDialog.ConfirmationDialog;
    }

    function dialogHTMLElementBoilerplate(text) {
        var dialogBox = document.createElement("div");
        dialogBox.classList.add(_strings2.default.class_dialog);
        var label = document.createElement("p");
        label.textContent = text;
        dialogBox.appendChild(label);
        return dialogBox;
    }

    function alertDialogHTMLElement(dialog) {
        var alertDialogBox = dialogHTMLElementBoilerplate(dialog.text);
        alertDialogBox.classList.add(_strings2.default.class_dialog_alert);
        var buttonOK = document.createElement("button");
        buttonOK.textContent = LABEL_ALERT_OK;
        alertDialogBox.appendChild(buttonOK);

        function alertDialogEventHandler() {
            currentDialogClosed();
        }
        // Event listener:
        buttonOK.addEventListener("click", alertDialogEventHandler);

        return alertDialogBox;
    }

    function confirmationDialogHTMLElement(confirmationDialog) {
        var confirmationDialogBox = dialogHTMLElementBoilerplate(confirmationDialog.text);
        confirmationDialogBox.classList.add(_strings2.default.class_dialog_confirmation);
        var buttonYes = document.createElement("button");
        buttonYes.textContent = LABEL_CONFIRM_YES;
        var buttonNo = document.createElement("button");
        buttonNo.textContent = LABEL_CONFIRM_NO;
        confirmationDialogBox.appendChild(buttonYes);
        confirmationDialogBox.appendChild(buttonNo);

        function confirmationDialogEventHandler(response) {
            return function () {
                currentDialogClosed();
                if (response === true) {
                    confirmationDialog.callback();
                }
            };
        }
        // Event listeners:
        buttonYes.addEventListener("click", confirmationDialogEventHandler(true));
        buttonNo.addEventListener("click", confirmationDialogEventHandler(false));

        return confirmationDialogBox;
    }

    function dialogHTMLElement(dialog) {
        if (dialog instanceof _ConfirmationDialog.ConfirmationDialog) {
            return confirmationDialogHTMLElement(dialog);
        } else if (dialog instanceof _Dialog.Dialog) {
            return alertDialogHTMLElement(dialog);
        }
        throw new TypeError(dialog + " is not a valid dialog.");
    }

    function resetScoreboardEntry(entry) {
        entry.classList.remove("active");
    }

    function resetScoreboard() {
        Array.from(scoreboard.children).forEach(resetScoreboardEntry);
    }

    function resetResults() {
        Array.from(results.children).forEach(resetScoreboardEntry);
    }

    function setCursorBehavior(behavior) {
        switch (behavior) {
            case _strings2.default.cursor_visible:
                document.body.classList.remove(_strings2.default.class_nocursor);
                break;
            case _strings2.default.cursor_hidden:
                document.body.classList.add(_strings2.default.class_nocursor);
                break;
            default:
                (0, _utilities.logError)("Cannot set cursor behavior to '" + behavior + "'.");
        }
    }

    function setTemporaryCursorVisibility(tempCursorActive) {
        if (tempCursorActive) {
            document.body.classList.add(_strings2.default.class_tempcursor);
        } else {
            document.body.classList.remove(_strings2.default.class_tempcursor);
        }
    }

    function settingsEntryShouldBeHalfWidth(preference) {
        if (preference instanceof _MultichoicePreference.MultichoicePreference) {
            var labels = preference.options.map(function (option) {
                return option.label;
            });
            var longestValueLabel = labels.reduce(function (acc, current) {
                return current.length > acc.length ? current : acc;
            });
            return longestValueLabel.length <= MULTICHOICE_LABEL_MAX_LENGTH_FOR_HALFWIDTH_FIELDSET;
        } else {
            return false;
        }
    }

    function settingsEntryHTMLElement(preference, preferenceValue) {
        if (!(preference instanceof _Preference.Preference)) {
            throw new TypeError(preference + " is not a preference.");
        }

        // Common
        var div = document.createElement("div");
        var label = document.createElement("label");
        label.textContent = preference.label;
        label.setAttribute("for", "" + _strings2.default.html_name_preference_prefix + preference.key);
        var description = document.createElement("aside");
        description.textContent = preference.description;
        description.classList.add(_strings2.default.class_description);

        // Boolean
        if (preference instanceof _BooleanPreference.BooleanPreference) {
            var input = document.createElement("input");
            input.type = "checkbox";
            input.dataset.key = preference.key;
            input.id = _strings2.default.html_name_preference_prefix + preference.key;
            input.checked = preferenceValue === true;
            div.appendChild(input);
            div.appendChild(label);
        }

        // Multichoice
        else if (preference instanceof _MultichoicePreference.MultichoicePreference) {
                var fieldset = document.createElement("fieldset");
                var legend = document.createElement("legend");
                legend.textContent = preference.label;
                fieldset.appendChild(legend);
                preference.options.forEach(function (option) {
                    var id = _strings2.default.html_name_preference_prefix + preference.key + "-" + option.key;
                    var radioButton = document.createElement("input");
                    radioButton.type = "radio";
                    radioButton.id = id;
                    radioButton.name = _strings2.default.html_name_preference_prefix + preference.key;
                    radioButton.value = option.key;
                    radioButton.dataset.key = preference.key;
                    radioButton.checked = preferenceValue === option.key;
                    var radioButtonLabel = document.createElement("label");
                    radioButtonLabel.textContent = option.label;
                    radioButtonLabel.setAttribute("for", id);
                    fieldset.appendChild(radioButton);
                    fieldset.appendChild(radioButtonLabel);
                });
                div.appendChild(fieldset);
                if (settingsEntryShouldBeHalfWidth(preference)) {
                    div.classList.add(_strings2.default.class_half_width);
                }
            }

            // Range
            else if (preference instanceof _RangePreference.RangePreference) {
                    var isIntegerRange = preference instanceof _IntegerRangePreference.IntegerRangePreference;
                    div.appendChild(label);
                    var _input = document.createElement("input");
                    _input.type = "number";
                    _input.dataset.key = preference.key;
                    _input.dataset.numberType = isIntegerRange ? _strings2.default.pref_number_type_integer : _strings2.default.pref_number_type_float;
                    _input.name = _strings2.default.html_name_preference_prefix + preference.key;
                    _input.setAttribute("step", isIntegerRange ? 1 : FLOAT_RANGE_PREFERENCE_STEP);
                    _input.setAttribute("min", preference.min);
                    _input.setAttribute("max", preference.max);
                    _input.value = preferenceValue;
                    div.appendChild(_input);
                }

        div.appendChild(description);
        return div;
    }

    // PUBLIC API

    function keyPressed(event, callback) {
        if (isShowingDialog()) {
            var currentlyFocusedButton = currentDialogWithBox.box.querySelector(BUTTON_TAG_NAME + ":focus");
            var shiftIsDown = _utilities.Keyboard.isDown(_utilities.KEY.SHIFT);
            var previousButton = void 0,
                nextButton = void 0;
            if (isButton(currentlyFocusedButton)) {
                previousButton = isButton(currentlyFocusedButton.previousSibling) ? currentlyFocusedButton.previousSibling : null;
                nextButton = isButton(currentlyFocusedButton.nextSibling) ? currentlyFocusedButton.nextSibling : null;
            }
            switch (event.keyCode) {
                case _utilities.KEY.SPACE:
                case _utilities.KEY.ENTER:
                    // Necessary because buttons do not automatically react to Space until keyup, making them feel sluggish compared to when Enter is used.
                    if (isButton(currentlyFocusedButton)) {
                        currentlyFocusedButton.click();
                    }
                    break;
                case _utilities.KEY.ESCAPE:
                    if (escapeShouldCloseCurrentDialog()) {
                        currentDialogClosed();
                    }
                    break;
                case _utilities.KEY.TAB:
                    event.preventDefault();
                    if (shiftIsDown) {
                        if (isButton(previousButton)) {
                            previousButton.focus();
                        }
                    } else if (isButton(nextButton)) {
                        nextButton.focus();
                    }
                    break;
                case _utilities.KEY.LEFT_ARROW:
                    if (isButton(previousButton)) {
                        previousButton.focus();
                    }
                    break;
                case _utilities.KEY.RIGHT_ARROW:
                    if (isButton(nextButton)) {
                        nextButton.focus();
                    }
                    break;
                default:
                    callback(event);
            }
        } else {
            callback(event);
        }
    }

    function showDialog(dialog) {
        if (isShowingDialog()) {
            queuedDialogs.push(dialog);
        } else {
            showDialogRightAway(dialog);
        }
    }

    function isShowingDialog() {
        return currentDialogWithBox !== null;
    }

    function setEdgePadding(padding) {
        left.style.width = ORIGINAL_LEFT_WIDTH + padding + "px";
    }

    function setBlurryScaling(allowed) {
        document.body.classList[allowed === true ? "add" : "remove"](_strings2.default.class_blurry);
    }

    function playerReady(id) {
        var index = id - 1;
        var entry = controls.children[index];
        if (!isLobbyEntry(entry)) {
            (0, _utilities.logWarning)("Cannot mark player " + id + " as ready because controls.children[" + index + "] (" + controls.children[index] + ") is not a valid lobby entry.");
        } else {
            entry.children[1].classList.add(_strings2.default.class_active);
        }
    }

    function playerUnready(id) {
        var index = id - 1;
        var entry = controls.children[index];
        if (!isLobbyEntry(entry)) {
            (0, _utilities.logWarning)("Cannot mark player " + id + " as unready because controls.children[" + index + "] (" + controls.children[index] + ") is not a valid lobby entry.");
        } else {
            entry.children[1].classList.remove(_strings2.default.class_active);
        }
    }

    function allPlayersUnready() {
        for (var id = 1; id <= controls.children.length; id++) {
            playerUnready(id);
        }
    }

    function gameStarted() {
        hideLobby();
    }

    function gameQuit() {
        hideKonecHry();
        showLobby();
        clearMessages();
        resetScoreboard();
        resetResults();
        allPlayersUnready();
        setCursorBehavior(_strings2.default.cursor_visible);
    }

    function konecHry() {
        showKonecHry();
        resetScoreboard();
    }

    function showKonecHry() {
        KONEC_HRY.classList.remove(_strings2.default.class_hidden);
    }

    function hideKonecHry() {
        KONEC_HRY.classList.add(_strings2.default.class_hidden);
    }

    function showMessage(message) {
        if (!currentMessages.includes(message)) {
            currentMessages.push(message);
        }
        updateMessages(currentMessages);
    }

    function showSettings() {
        showingSettings = true;
        settings.classList.remove(_strings2.default.class_hidden);
    }

    function hideSettings() {
        showingSettings = false;
        settings.classList.add(_strings2.default.class_hidden);
    }

    function isShowingSettings() {
        return showingSettings;
    }

    function updateSettingsForm(preferencesWithData) {
        (0, _utilities.flush)(settingsForm);
        var settingsEntries = preferencesWithData.map(function (preferenceWithData) {
            return settingsEntryHTMLElement(preferenceWithData.preference, preferenceWithData.value);
        });
        // Add special class to half-width divs on the right hand side:
        var consecutiveHalfWidthDivs = 0;
        for (var i = 0; i < settingsEntries.length; i++) {
            var currentEntry = settingsEntries[i];
            if (currentEntry.classList.contains(_strings2.default.class_half_width)) {
                consecutiveHalfWidthDivs++;
                if (consecutiveHalfWidthDivs % 2 === 0) {
                    // Even number of consecutive half-width divs, so this one will be on the right hand side.
                    currentEntry.classList.add(_strings2.default.class_right_hand_side);
                }
            } else {
                consecutiveHalfWidthDivs = 0;
            }
        }
        settingsEntries.forEach(function (settingsEntry) {
            settingsForm.appendChild(settingsEntry);
        });
    }

    function parseSettingsForm() {
        var newSettings = [];
        // <input> elements:
        var inputs = settingsForm.querySelectorAll("input");
        Array.from(inputs).forEach(function (input) {
            if (input.type === "checkbox") {
                // checkbox
                newSettings.push({ key: input.dataset.key, value: input.checked });
            } else if (input.type === "radio") {
                // radio
                if (input.checked === true) {
                    newSettings.push({ key: input.dataset.key, value: input.value });
                }
            } else if (input.type === "number") {
                // number
                newSettings.push({ key: input.dataset.key, value: (input.dataset.numberType === _strings2.default.pref_number_type_integer ? parseInt : parseFloat)(input.value) });
            } else {
                // text
                newSettings.push({ key: input.dataset.key, value: input.value.toString() });
            }
        });
        // <select> elements:
        var selects = settingsForm.querySelectorAll("select");
        Array.from(selects).forEach(function (select) {
            newSettings.push({ key: select.dataset.key, value: select.options[select.selectedIndex].value });
        });
        return newSettings;
    }

    function hideMessage(message) {
        currentMessages = currentMessages.filter(function (msg) {
            return msg !== message;
        });
        updateMessages(currentMessages);
    }

    function updateMessages(messages) {
        if (!(0, _utilities.isHTMLElement)(messagesContainer)) {
            (0, _utilities.logWarning)("Cannot update messages because " + messagesContainer + " is not an HTML element.");
        } else {
            (0, _utilities.flush)(messagesContainer);
            messages.forEach(function (message) {
                messagesContainer.insertBefore(message.toHTMLElement(), null);
            });
        }
    }

    function clearMessages() {
        currentMessages = [];
        updateMessages(currentMessages);
    }

    function setMessageMode(mode) {
        (0, _utilities.log)("Setting message mode to " + mode + ".");
        switch (mode) {
            case _strings2.default.pref_value_hints_warnings_only:
                messagesContainer.classList.remove(_strings2.default.class_hints_none);
                messagesContainer.classList.add(_strings2.default.class_hints_warnings_only);
                break;
            case _strings2.default.pref_value_hints_none:
                messagesContainer.classList.remove(_strings2.default.class_hints_warnings_only);
                messagesContainer.classList.add(_strings2.default.class_hints_none);
                break;
            default:
                messagesContainer.classList.remove(_strings2.default.class_hints_warnings_only);
                messagesContainer.classList.remove(_strings2.default.class_hints_none);
        }
    }

    function updateBoard(board, id, newScore) {
        if (!(0, _utilities.isHTMLElement)(board)) {
            (0, _utilities.logWarning)("Cannot update any entry in " + board + " because it is not an HTML element.");
        } else {
            var entry = board.children[id - 1];
            if (!(0, _utilities.isHTMLElement)(entry)) {
                (0, _utilities.logWarning)("Cannot update score of player " + id + " because " + entry + " is not an HTML element.");
            } else {
                // The entry is an HTML element; let's update it!
                var digitClassFactory = function digitClassFactory(digit) {
                    return "d" + digit;
                };
                var createDigit = function createDigit() {
                    return document.createElement("div");
                };
                // Turn 528 into ["d5", "d2", "d8"]:
                var newScoreDigitClasses = newScore.toString().split("").map(digitClassFactory);
                // Remove everything from the entry element before we insert new digits:
                (0, _utilities.flush)(entry);
                entry.classList.add("active");
                newScoreDigitClasses.forEach(function (digitClass, index) {
                    var digitElement = createDigit(); // A completely clean element ...
                    digitElement.classList.add(newScoreDigitClasses[index]); // ... that now has a digit class.
                    entry.appendChild(digitElement);
                });
            }
        }
    }

    function updateScoreOfPlayer(id, newScore) {
        updateBoard(scoreboard, id, newScore);
        updateBoard(results, id, newScore);
    }

    return {
        keyPressed: keyPressed,
        playerReady: playerReady,
        playerUnready: playerUnready,
        gameStarted: gameStarted,
        gameQuit: gameQuit,
        konecHry: konecHry,
        showDialog: showDialog,
        isShowingDialog: isShowingDialog,
        showSettings: showSettings,
        hideSettings: hideSettings,
        isShowingSettings: isShowingSettings,
        updateSettingsForm: updateSettingsForm,
        parseSettingsForm: parseSettingsForm,
        updateScoreOfPlayer: updateScoreOfPlayer,
        updateMessages: updateMessages,
        showMessage: showMessage,
        hideMessage: hideMessage,
        clearMessages: clearMessages,
        setMessageMode: setMessageMode,
        setCursorBehavior: setCursorBehavior,
        setBlurryScaling: setBlurryScaling,
        setEdgePadding: setEdgePadding
    };
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Game = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mainloopMin = __webpack_require__(23);

var _mainloopMin2 = _interopRequireDefault(_mainloopMin);

var _Player = __webpack_require__(5);

var _Round = __webpack_require__(20);

var _utilities = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Game = exports.Game = function () {
    function Game(config, renderer, guiController) {
        _classCallCheck(this, Game);

        // Class variables:
        this.constructor.PRACTICE = "practice";
        this.constructor.COMPETITIVE = "competitive";
        this.constructor.DEFAULT_MODE = this.constructor.PRACTICE;
        this.constructor.DEFAULT_TARGET_SCORE = 10;
        this.constructor.MAX_TARGET_SCORE = 1000;
        this.constructor.MAX_PLAYERS = 255; // since we use a Uint8Array
        this.constructor.MAX_QUOTA_THAT_SPAWN_CIRCLES_MAY_FILL = 0.5; // out of available spawn area
        this.constructor.DESIRED_MINIMUM_SPAWN_DISTANCE_TURNING_RADIUS_FACTOR = 1;
        this.constructor.KONEC_HRY = "KONEC HRY!";

        if (renderer === undefined) {
            throw new TypeError("Cannot create a Game with no renderer.");
        } else if (!this.constructor.isRenderer(renderer)) {
            throw new TypeError(renderer + " is not a valid renderer.");
        }

        if (guiController === undefined) {
            throw new TypeError("Cannot create a Game with no GUI controller.");
        } else if (!this.constructor.isGUIController(guiController)) {
            throw new TypeError(guiController + " is not a valid GUI controller.");
        }

        // Instance variables:
        this.config = config;
        this.width = config.canvas.width;
        this.height = config.canvas.height;
        this.pixels = null; // The actual array is created in start(), because the canvas width and height may have changed by then.
        this.players = [];
        this.rounds = [];
        this.renderer = renderer;
        this.guiController = guiController;
        this.mode = this.constructor.DEFAULT_MODE;
        this.preventSpawnkill = config.preventSpawnkill;
        this.totalNumberOfTicks = 0;
        this.targetScore = null;
        this.initMainLoop();
        this.started = false;
        this.ended = false;
        this.proceedHintTimer = null;
        this.quitHintTimer = null;
    }

    _createClass(Game, [{
        key: "edgeOfSquare",
        value: function edgeOfSquare(coordinate) {
            return Math.round(coordinate - this.config.thickness / 2);
        }
    }, {
        key: "maxPlayers",
        value: function maxPlayers() {
            return this.constructor.MAX_PLAYERS;
        }
    }, {
        key: "maxTicksBetweenDraws",
        value: function maxTicksBetweenDraws() {
            return Math.max(Math.floor(this.config.tickrate / this.config.speed), 1);
        }

        // Computes the angle change for one tick when turning, in radians:

    }, {
        key: "computeAngleChange",
        value: function computeAngleChange() {
            return this.config.speed / (this.config.tickrate * this.config.turningRadius);
        }
    }, {
        key: "computeSpawnArea",
        value: function computeSpawnArea() {
            return {
                x_min: this.config.spawnMargin,
                y_min: this.config.spawnMargin,
                x_max: this.width - this.config.spawnMargin,
                y_max: this.height - this.config.spawnMargin
            };
        }
    }, {
        key: "computeFrontCornerPixel",
        value: function computeFrontCornerPixel(edge, dir) {
            var t = this.config.thickness;
            var cf = 100;
            return (cf * edge + cf * (t - 1) / 2 + cf * dir * (t - 1) / 2) / cf;
        }
    }, {
        key: "computeFrontEdgePixel",
        value: function computeFrontEdgePixel(edge, dir_parallel, dir_perpendicular, i) {
            var t = this.config.thickness;
            return edge + Math.abs(dir_parallel) * (t - 1) / 2 + dir_parallel * (t - 1) / 2 + Math.abs(dir_perpendicular) * i;
        }
    }, {
        key: "computeHitbox",
        value: function computeHitbox(player, left, top) {
            var hitboxPixels = [];
            var lastPosition = player.getLastPosition();
            var dir_horizontal = left - lastPosition.left; // positive => going right; negative => going left
            var dir_vertical = top - lastPosition.top; // positive => going down;  negative => going up
            if ((0, _utilities.sameAbs)(dir_horizontal, dir_vertical)) {
                // "45 degree" draw
                var frontPixel_left = this.computeFrontCornerPixel(left, dir_horizontal);
                var frontPixel_top = this.computeFrontCornerPixel(top, dir_vertical);
                hitboxPixels.push(this.pixelAddress(frontPixel_left, frontPixel_top));
            } else {
                // "90 degree" draw
                for (var i = 0; i < this.config.thickness; i++) {
                    var _frontPixel_left = this.computeFrontEdgePixel(left, dir_horizontal, dir_vertical, i);
                    var _frontPixel_top = this.computeFrontEdgePixel(top, dir_vertical, dir_horizontal, i);
                    hitboxPixels.push(this.pixelAddress(_frontPixel_left, _frontPixel_top));
                }
            }
            return hitboxPixels;
        }
    }, {
        key: "desiredMinimumSpawnDistance",
        value: function desiredMinimumSpawnDistance() {
            // to closest opponent
            // This is calculated by multiplying the turning radius with a constant factor and then adding the Kurve thickness.
            var turningRadiusPart = this.config.turningRadius * this.constructor.DESIRED_MINIMUM_SPAWN_DISTANCE_TURNING_RADIUS_FACTOR;
            return (0, _utilities.round)(this.config.thickness + turningRadiusPart, 2);
        }
    }, {
        key: "safeMinimumSpawnDistance",
        value: function safeMinimumSpawnDistance() {
            // to closest opponent, without risking infinite or too much sampling
            var spawnAreaCoordinates = this.computeSpawnArea();
            var availableSpawnArea = (spawnAreaCoordinates.x_max - spawnAreaCoordinates.x_min) * (spawnAreaCoordinates.y_max - spawnAreaCoordinates.y_min);
            var maximumSafeDistance = Math.sqrt(this.constructor.MAX_QUOTA_THAT_SPAWN_CIRCLES_MAY_FILL * availableSpawnArea / (this.getNumberOfPlayers() * Math.PI));
            return Math.min(this.desiredMinimumSpawnDistance(), (0, _utilities.round)(maximumSafeDistance, 2));
        }
    }, {
        key: "isSafeSpawnPosition",
        value: function isSafeSpawnPosition(pos) {
            function distanceBetween(pos1, pos2) {
                return Math.sqrt(Math.pow(pos2.x - pos1.x, 2) + Math.pow(pos2.y - pos1.y, 2));
            }
            for (var i = 0; i < this.players.length; i++) {
                var playerPos = { x: this.players[i].x, y: this.players[i].y };
                if (distanceBetween(playerPos, pos) < this.safeMinimumSpawnDistance()) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "safeSpawnPosition",
        value: function safeSpawnPosition() {
            var safePos = void 0;
            do {
                safePos = this.randomSpawnPosition();
            } while (!this.isSafeSpawnPosition(safePos));
            return safePos;
        }
    }, {
        key: "randomSpawnPosition",
        value: function randomSpawnPosition() {
            var spawnArea = this.computeSpawnArea();
            return {
                x: (0, _utilities.randomFloat)(spawnArea.x_min, spawnArea.x_max),
                y: (0, _utilities.randomFloat)(spawnArea.y_min, spawnArea.y_max)
            };
        }
    }, {
        key: "randomSpawnAngle",
        value: function randomSpawnAngle() {
            return (0, _utilities.randomFloat)(this.config.minSpawnAngle, this.config.maxSpawnAngle);
        }
    }, {
        key: "pixelAddress",
        value: function pixelAddress(x, y) {
            return y * this.width + x;
        }
    }, {
        key: "pixelAddressToCoordinates",
        value: function pixelAddressToCoordinates(addr) {
            var x = addr % this.width;
            var y = (addr - x) / this.width;
            return "(" + x + ", " + y + ")";
        }

        // GETTERS

    }, {
        key: "getMode",
        value: function getMode() {
            return this.mode;
        }
    }, {
        key: "getTargetScore",
        value: function getTargetScore() {
            return this.targetScore;
        }
    }, {
        key: "getPlayers",
        value: function getPlayers() {
            return this.players;
        }

        // Returns the player with the specified ID, or undefined if no such player exists:

    }, {
        key: "getPlayerByID",
        value: function getPlayerByID(id) {
            return this.players.find(function (player) {
                return player.hasID(id);
            });
        }
    }, {
        key: "getLivePlayers",
        value: function getLivePlayers() {
            var isAlive = this.constructor.isAlive;
            return this.players.filter(isAlive);
        }
    }, {
        key: "getNumberOfPlayers",
        value: function getNumberOfPlayers() {
            return this.players.length;
        }
    }, {
        key: "getNumberOfLivePlayers",
        value: function getNumberOfLivePlayers() {
            return this.getLivePlayers().length;
        }
    }, {
        key: "getScoreOfPlayer",
        value: function getScoreOfPlayer(id) {
            var accumulateScore = function accumulateScore(sum, round) {
                return sum + round.getSuccessOfPlayer(id);
            };
            return this.rounds.reduce(accumulateScore, 0);
        }
    }, {
        key: "getCurrentRound",
        value: function getCurrentRound() {
            return this.rounds[this.rounds.length - 1];
        }

        // SETTERS

    }, {
        key: "setMode",
        value: function setMode(mode) {
            if (mode === this.constructor.COMPETITIVE || mode === this.constructor.PRACTICE) {
                (0, _utilities.log)("Setting game mode to " + mode + ".");
                this.mode = mode;
            } else {
                (0, _utilities.logError)(mode + " is not a valid game mode. Keeping " + this.getMode() + ".");
            }
        }
    }, {
        key: "setTargetScore",
        value: function setTargetScore(score) {
            var ts = this.constructor.DEFAULT_TARGET_SCORE;
            var mts = this.constructor.MAX_TARGET_SCORE;
            // Neither floats nor negative numbers are allowed:
            if ((0, _utilities.isInt)(score) && score > 0) {
                // Check if the desired target score is allowed:
                if (score > mts) {
                    // It is too high. Fall back to max value:
                    (0, _utilities.logWarning)(score + " is larger than the maximum allowed target score of " + mts + ". Falling back to " + mts + ".");
                    ts = mts;
                } else {
                    // The desired target score is OK!
                    (0, _utilities.log)("Setting target score to " + score + ".");
                    ts = score;
                }
            } else {
                (0, _utilities.logWarning)(score + " is not a valid target score. Defaulting to " + ts + ".");
            }
            this.targetScore = ts;
        }
    }, {
        key: "setSize",
        value: function setSize(width, height) {
            this.width = width;
            this.height = height;
            this.renderer.setSize(width, height);
        }
    }, {
        key: "setPreventSpawnkill",
        value: function setPreventSpawnkill(mode) {
            this.preventSpawnkill = mode;
        }

        // CHECKERS

    }, {
        key: "isStarted",
        value: function isStarted() {
            return this.started;
        }
    }, {
        key: "isEnded",
        value: function isEnded() {
            return this.ended;
        }

        /** Returns true if a round is over (including when KONEC HRY is being shown). */

    }, {
        key: "isPostRound",
        value: function isPostRound() {
            return this.getCurrentRound().getResults().length === this.getNumberOfPlayers();
        }
    }, {
        key: "isLive",
        value: function isLive() {
            if (this.isCompetitive()) {
                return this.getNumberOfLivePlayers() > 1;
            } else {
                return this.getNumberOfLivePlayers() > 0;
            }
        }

        // Caution: Returns true if called during the spawn procedure, since it only checks whether the game is live or not.

    }, {
        key: "isRoundOver",
        value: function isRoundOver() {
            return !this.isLive();
        }
    }, {
        key: "isGameOver",
        value: function isGameOver() {
            var _this = this;

            var hasReachedTargetScore = function hasReachedTargetScore(player) {
                return _this.getScoreOfPlayer(player.getID()) >= _this.getTargetScore();
            };
            return !this.isLive() && this.isCompetitive() && this.players.some(hasReachedTargetScore);
        }
    }, {
        key: "isCompetitive",
        value: function isCompetitive() {
            return this.getMode() === this.constructor.COMPETITIVE;
        }
    }, {
        key: "isOccupiedPixelAddress",
        value: function isOccupiedPixelAddress(addr) {
            return this.pixels[addr] > 0;
        }
    }, {
        key: "isCrashing",
        value: function isCrashing(player, left, top) {
            var hitboxPixels = this.computeHitbox(player, left, top);
            return hitboxPixels.some(this.isOccupiedPixelAddress, this);
        }

        /**
         * Checks whether a draw at the specified coordinates is inside the field.
         * @param {Number} left The x coordinate of the left edge of the draw.
         * @param {Number} top  The y coordinate of the top edge of the draw.
         */

    }, {
        key: "isOnField",
        value: function isOnField(left, top) {
            return left >= 0 && top >= 0 && left + this.config.thickness <= this.width && top + this.config.thickness <= this.height;
        }

        /** 
         * Checks whether there is a player with a specific ID in the game.
         * @param {Number} id The ID to check for.
         */

    }, {
        key: "hasPlayer",
        value: function hasPlayer(id) {
            return _Player.Player.isPlayer(this.getPlayerByID(id));
        }

        // DOERS

        /** 
         * Adds a player to the game.
         * @param {Player} player The player to add.
         */

    }, {
        key: "addPlayer",
        value: function addPlayer(player) {
            var maxPlayers = this.maxPlayers();
            if (!_Player.Player.isPlayer(player)) {
                throw new TypeError("Cannot add " + player + " to the game because it is not a player.");
            } else if (player.getID() > maxPlayers) {
                throw new RangeError("Cannot add " + player + " to the game because player IDs larger than " + maxPlayers + " are not supported.");
            } else if (this.hasPlayer(player.getID())) {
                (0, _utilities.logWarning)("Not adding " + player + " to the game because there is already a player with ID " + player.getID() + ".");
            } else {
                (0, _utilities.log)(player + " ready!");
                this.players.push(player);
                player.setMaxSpeed(this.config.speed);
                this.GUI_playerReady(player.getID());
            }
        }

        /** 
         * Removes a player from the game.
         * @param {Number} id The ID of the player to remove.
         */

    }, {
        key: "removePlayer",
        value: function removePlayer(id) {
            var playerToRemove = this.getPlayerByID(id);
            // Notify GUI iff the player exists:
            if (_Player.Player.isPlayer(playerToRemove)) {
                (0, _utilities.log)(playerToRemove + " unready!");
                this.GUI_playerUnready(id);
            }
            // Update this.players:
            this.players = this.players.filter(function (player) {
                return player !== playerToRemove;
            });
        }

        /** Starts the game. */

    }, {
        key: "start",
        value: function start() {
            var _this2 = this;

            if (this.isCompetitive()) {
                this.setTargetScore(this.constructor.calculateTargetScore(this.getNumberOfPlayers()));
                this.players.forEach(function (player) {
                    _this2.GUI_updateScoreOfPlayer(player.getID(), 0);
                });
            }
            (0, _utilities.log)("Starting game!");
            this.GUI_gameStarted();
            _mainloopMin2.default.start();
            this.started = true;
            this.pixels = new Uint8Array(this.width * this.height);
            this.beginNewRound();
        }
    }, {
        key: "pause",
        value: function pause() {
            _mainloopMin2.default.stop();
        }
    }, {
        key: "isPaused",
        value: function isPaused() {
            return !_mainloopMin2.default.isRunning();
        }
    }, {
        key: "resume",
        value: function resume() {
            _mainloopMin2.default.start();
        }

        /** Announce KONEC HRY, show results etc. */

    }, {
        key: "konecHry",
        value: function konecHry() {
            (0, _utilities.log)(this.constructor.KONEC_HRY);
            this.ended = true;
            this.GUI_konecHry();
            this.quitHintTimer = setTimeout(this.showQuitHint.bind(this), this.config.hintDelay);
        }
    }, {
        key: "quit",
        value: function quit() {
            clearTimeout(this.quitHintTimer);
            clearTimeout(this.proceedHintTimer);
        }
    }, {
        key: "clearField",
        value: function clearField() {
            this.pixels.fill(0);
            this.Render_clearField();
        }
    }, {
        key: "showProceedHint",
        value: function showProceedHint() {
            this.GUI_showMessage(this.config.messages.next);
        }
    }, {
        key: "hideProceedHint",
        value: function hideProceedHint() {
            clearTimeout(this.proceedHintTimer);
            this.GUI_hideMessage(this.config.messages.next);
        }
    }, {
        key: "showQuitHint",
        value: function showQuitHint() {
            this.GUI_showMessage(this.config.messages.quit);
        }
    }, {
        key: "hideQuitHint",
        value: function hideQuitHint() {
            clearTimeout(this.quitHintTimer);
            this.GUI_hideMessage(this.config.messages.quit);
        }
    }, {
        key: "beginNewRound",
        value: function beginNewRound() {
            this.rounds.push(new _Round.Round());
            (0, _utilities.log)("======== ROUND " + this.rounds.length + " ========");
            this.resetPlayers();
            this.clearField();
            // Sort the players by their IDs so they spawn in the correct order:
            this.sortPlayers();
            this.spawnAndStartPlayers();
        }
    }, {
        key: "endRound",
        value: function endRound() {
            this.stopPlayers();
            this.proceedHintTimer = setTimeout(this.showProceedHint.bind(this), this.config.hintDelay);
        }
    }, {
        key: "sortPlayers",
        value: function sortPlayers() {
            this.players.sort(function (a, b) {
                return a.getID() - b.getID();
            });
        }
    }, {
        key: "startPlayer",
        value: function startPlayer(player) {
            player.start();
        }
    }, {
        key: "stopPlayer",
        value: function stopPlayer(player) {
            player.stop();
        }
    }, {
        key: "resetPlayer",
        value: function resetPlayer(player) {
            player.reset();
        }

        /** Starts all players. */

    }, {
        key: "startPlayers",
        value: function startPlayers() {
            this.players.forEach(this.startPlayer);
        }
    }, {
        key: "stopPlayers",
        value: function stopPlayers() {
            this.players.forEach(this.stopPlayer);
        }
    }, {
        key: "resetPlayers",
        value: function resetPlayers() {
            this.players.forEach(this.resetPlayer);
        }
    }, {
        key: "occupyPixel",
        value: function occupyPixel(x, y, id) {
            this.pixels[this.pixelAddress(x, y)] = id;
        }
    }, {
        key: "occupy",
        value: function occupy(player, left, top) {
            var right = left + this.config.thickness;
            var bottom = top + this.config.thickness;
            var id = player.getID();
            (0, _utilities.forfor)(top, bottom, left, right, this.occupyPixel.bind(this), id);
            this.Render_drawSquare(left, top, player.getColor());
        }
    }, {
        key: "flicker",
        value: function flicker(player) {
            var _this3 = this;

            var stopFlickering = function stopFlickering() {
                clearInterval(flickerTicker);
                var left = _this3.edgeOfSquare(player.x);
                var top = _this3.edgeOfSquare(player.y);
                _this3.Render_drawSquare(left, top, player.getColor());
            };
            var self = this;
            var left = this.edgeOfSquare(player.x);
            var top = this.edgeOfSquare(player.y);
            var color = player.getColor();
            var isVisible = false;
            var flickerTicker = setInterval(function () {
                if (isVisible) {
                    _this3.Render_clearSquare(left, top);
                } else {
                    _this3.Render_drawSquare(left, top, color);
                }
                isVisible = !isVisible;
            }, 1000 / this.config.flickerFrequency);
            setTimeout(stopFlickering, self.config.flickerDuration);
        }
    }, {
        key: "spawn",
        value: function spawn(player, position, direction) {
            (0, _utilities.log)(player + " spawning at (" + (0, _utilities.round)(position.x, 2) + ", " + (0, _utilities.round)(position.y, 2) + ").");
            player.x = position.x;
            player.y = position.y;
            player.direction = direction;
            var left = this.edgeOfSquare(player.x);
            var top = this.edgeOfSquare(player.y);
            player.beAt(left, top);
            this.occupy(player, left, top);
            this.flicker(player);
        }

        /** Spawns and then starts all players. */

    }, {
        key: "spawnAndStartPlayers",
        value: function spawnAndStartPlayers() {
            var self = this;
            (0, _utilities.log)("Spawnkill prevention is " + (this.preventSpawnkill ? "enabled. No two players will spawn within " + self.safeMinimumSpawnDistance() + " Kuxels of each other." : "disabled. Players may spawn arbitrarily close to each other."));
            // Spawn each player, then wait for it to finish flickering before spawning the next one:
            (function spawnPlayer(i) {
                if (i < self.players.length) {
                    var spawnPosition = self.preventSpawnkill ? self.safeSpawnPosition() : self.randomSpawnPosition();
                    self.spawn(self.players[i], spawnPosition, self.randomSpawnAngle());
                    setTimeout(function () {
                        return spawnPlayer(++i);
                    }, self.config.flickerDuration);
                } else {
                    // All players have spawned. Start them!
                    self.startPlayers();
                }
            })(0);
        }

        /**
         * Draws a specific player.
         */

    }, {
        key: "drawPlayer",
        value: function drawPlayer(player) {
            var thickness = this.config.thickness;
            while (player.isAlive() && !player.queuedDraws.isEmpty()) {
                var color = player.getColor();
                var lastPosition = player.getLastPosition();
                var currentDraw = player.queuedDraws.dequeue();
                var left = this.edgeOfSquare(currentDraw.x);
                var top = this.edgeOfSquare(currentDraw.y);
                if (!player.justWasAt(left, top)) {
                    // The new position is not identical to the last one.
                    var diff_left = left - player.getLastPosition().left;
                    var diff_top = top - player.getLastPosition().top;
                    if (!this.isOnField(left, top)) {
                        // The player wants to draw outside the playing field => DIE.
                        this.death(player, "crashed into the wall");
                        this.occupy(player, lastPosition.left, lastPosition.top);
                    } else if (this.isCrashing(player, left, top)) {
                        // The player wants to draw on a spot occupied by a Kurve => DIE.
                        this.death(player, "crashed");
                        this.occupy(player, lastPosition.left, lastPosition.top);
                    } else {
                        // The player is not dying.
                        player.beAt(left, top);
                        if (!player.isHoly()) {
                            // The player is not holy, so it should draw.
                            this.occupy(player, left, top);
                        }
                    }
                }
            }
        }
    }, {
        key: "drawHead",
        value: function drawHead(player) {
            if (player.isAlive()) {
                var lastPosition = player.getLastPosition();
                var left = lastPosition.left;
                var top = lastPosition.top;
                var color = player.getColor();
                this.Render_drawHead(left, top, color);
            }
        }
    }, {
        key: "updateGUIScoreboard",
        value: function updateGUIScoreboard() {
            var _this4 = this;

            var updateScore = function updateScore(player) {
                var id = player.getID();
                _this4.GUI_updateScoreOfPlayer(id, _this4.getScoreOfPlayer(id));
            };
            this.getLivePlayers().forEach(updateScore);
        }
    }, {
        key: "death",
        value: function death(player, cause) {
            player.die(cause);
            this.getCurrentRound().add(player);
            this.updateGUIScoreboard();
            if (this.isRoundOver()) {
                if (this.isCompetitive()) {
                    var isAlive = this.constructor.isAlive;
                    var winner = this.players.find(isAlive);
                    this.winRound(winner);
                }
                this.endRound();
            }
        }
    }, {
        key: "winRound",
        value: function winRound(player) {
            (0, _utilities.log)(player + " won the round.");
            // Ugly fix for the bug where the winner's head disappears when the round ends:
            this.occupy(player, this.edgeOfSquare(player.x), this.edgeOfSquare(player.y));
            this.getCurrentRound().add(player);
        }
    }, {
        key: "proceedKeyPressed",
        value: function proceedKeyPressed() {
            this.hideProceedHint();
            this.hideQuitHint();
            if (this.isGameOver()) {
                // The game is over, so we should show KONEC HRY:
                this.konecHry();
            } else if (this.isPostRound()) {
                // We are post round and the game is not over, so we should proceed to the next round:
                this.beginNewRound();
            }
        }
    }, {
        key: "shouldShowReloadConfirmationOnReloadKey",
        value: function shouldShowReloadConfirmationOnReloadKey() {
            return this.isPostRound();
        }
    }, {
        key: "shouldQuitOnQuitKey",
        value: function shouldQuitOnQuitKey() {
            return this.isPostRound() && !this.isGameOver();
        }
    }, {
        key: "shouldQuitOnProceedKey",
        value: function shouldQuitOnProceedKey() {
            return this.isEnded();
        }

        // RENDERER AND GUI CONTROLLER COMMUNICATION

    }, {
        key: "GUI_playerReady",
        value: function GUI_playerReady(id) {
            this.guiController.playerReady(id);
        }
    }, {
        key: "GUI_playerUnready",
        value: function GUI_playerUnready(id) {
            this.guiController.playerUnready(id);
        }
    }, {
        key: "GUI_updateScoreOfPlayer",
        value: function GUI_updateScoreOfPlayer(id, newScore) {
            this.guiController.updateScoreOfPlayer(id, newScore);
        }
    }, {
        key: "GUI_gameStarted",
        value: function GUI_gameStarted() {
            this.guiController.gameStarted();
        }
    }, {
        key: "GUI_konecHry",
        value: function GUI_konecHry() {
            this.guiController.konecHry();
        }
    }, {
        key: "GUI_showMessage",
        value: function GUI_showMessage(message) {
            this.guiController.showMessage(message);
        }
    }, {
        key: "GUI_hideMessage",
        value: function GUI_hideMessage(message) {
            this.guiController.hideMessage(message);
        }
    }, {
        key: "Render_drawSquare",
        value: function Render_drawSquare(left, top, color) {
            this.renderer.drawSquare(left, top, this.config.thickness, color);
        }
    }, {
        key: "Render_drawHead",
        value: function Render_drawHead(left, top, color) {
            this.renderer.drawSquare_overlay(left, top, this.config.thickness, color);
        }
    }, {
        key: "Render_clearSquare",
        value: function Render_clearSquare(left, top) {
            this.renderer.clearSquare(left, top, this.config.thickness);
        }
    }, {
        key: "Render_clearHeads",
        value: function Render_clearHeads() {
            this.renderer.clearRectangle_overlay(0, 0, this.width, this.height);
        }
    }, {
        key: "Render_clearField",
        value: function Render_clearField() {
            this.renderer.clearRectangle(0, 0, this.width, this.height);
            this.renderer.clearRectangle_overlay(0, 0, this.width, this.height);
        }

        // MAIN LOOP


    }, {
        key: "updatePlayer",
        value: function updatePlayer(player, delta) {
            if (player.isAlive()) {
                var angleChange = this.computeAngleChange();
                var direction = player.getDirection();
                if (player.isPressingLeft()) {
                    direction = direction + angleChange; // let compound assignment not optimizable in V8
                }
                if (player.isPressingRight()) {
                    direction = direction - angleChange; // let compound assignment not optimizable in V8
                }
                // We use normalizeAngle so the angle stays in the interval -pi < dir <= pi:
                player.setDirection((0, _utilities.normalizeAngle)(direction));
                var theta = player.getVelocity() * delta / 1000;
                player.x += theta * Math.cos(player.direction);
                player.y -= theta * Math.sin(player.direction);
            }
        }

        /**
         * Updates everything on each tick.
         * @param {Number} delta
         *   The amount of time since the last update, in seconds.
         */

    }, {
        key: "update",
        value: function update(delta) {
            var _this5 = this;

            this.players.forEach(function (player) {
                _this5.updatePlayer(player, delta);
            });
            if (this.totalNumberOfTicks % this.maxTicksBetweenDraws() === 0) {
                this.getLivePlayers().forEach(function (player) {
                    player.enqueueDraw();
                });
            }
            this.totalNumberOfTicks++;
        }

        /**
         * Draws all players.
         */

    }, {
        key: "draw",
        value: function draw() {
            this.Render_clearHeads();
            this.players.forEach(this.drawPlayer, this);
            this.players.forEach(this.drawHead, this);
        }

        /**
         * Updates the FPS counter etc.
         * @param {Number} framerate
         *   The smoothed frames per second.
         * @param {Boolean} panic
         *   Whether the main loop panicked because the simulation fell too far behind real time.
         */

    }, {
        key: "end",
        value: function end(framerate, panic) {
            if (panic) {
                var discardedTime = Math.round(_mainloopMin2.default.resetFrameDelta());
                console.warn("Main loop panicked. Discarding " + discardedTime + "ms.");
            }
        }

        /**
         * Initiates the main loop.
         */

    }, {
        key: "initMainLoop",
        value: function initMainLoop() {
            this.MainLoop = _mainloopMin2.default;
            this.MainLoop.setUpdate(this.update.bind(this)).setDraw(this.draw.bind(this)).setEnd(this.end.bind(this)).setSimulationTimestep(1000 / this.config.tickrate).setMaxAllowedFPS(this.config.maxFramerate);
        }
    }], [{
        key: "isRenderer",
        value: function isRenderer(obj) {
            // TODO
            return obj !== undefined;
        }
    }, {
        key: "isGUIController",
        value: function isGUIController(obj) {
            // TODO
            return obj !== undefined;
        }
    }, {
        key: "isAlive",
        value: function isAlive(player) {
            return player.isAlive();
        }
    }, {
        key: "calculateTargetScore",
        value: function calculateTargetScore(numberOfPlayers) {
            // Default target score is (n-1) * 10 for n players:
            return (numberOfPlayers - 1) * 10;
        }
    }]);

    return Game;
}();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Renderer = Renderer;
function Renderer(mainCanvas, overlayCanvas) {

    var context_main = mainCanvas.getContext("2d");
    var context_overlay = overlayCanvas.getContext("2d");

    // PRIVATE FUNCTIONS:

    function _drawRectangle(context, left, top, width, height, color) {
        context.fillStyle = color;
        context.fillRect(left, top, width, height);
    }

    function _clearRectangle(context, left, top, width, height) {
        context.clearRect(left, top, width, height);
    }

    function _setSize(canvas, width, height) {
        canvas.width = width;
        canvas.height = height;
    }

    // PUBLIC API:

    function setSize(width, height) {
        _setSize(mainCanvas, width, height);
        _setSize(overlayCanvas, width, height);
    }

    // Main canvas:

    function drawSquare(left, top, size, color) {
        _drawRectangle(context_main, left, top, size, size, color);
    }

    function clearSquare(left, top, size) {
        _clearRectangle(context_main, left, top, size, size);
    }

    function clearRectangle(left, top, width, height) {
        _clearRectangle(context_main, left, top, width, height);
    }

    // Overlay canvas:

    function drawSquare_overlay(left, top, size, color) {
        _drawRectangle(context_overlay, left, top, size, size, color);
    }

    function clearSquare_overlay(left, top, size) {
        _clearRectangle(context_overlay, left, top, size, size);
    }

    function clearRectangle_overlay(left, top, width, height) {
        _clearRectangle(context_overlay, left, top, width, height);
    }

    return {
        drawSquare: drawSquare,
        clearSquare: clearSquare,
        clearRectangle: clearRectangle,
        drawSquare_overlay: drawSquare_overlay,
        clearSquare_overlay: clearSquare_overlay,
        clearRectangle_overlay: clearRectangle_overlay,
        setSize: setSize
    };
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InfoMessage = undefined;

var _Message2 = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoMessage = exports.InfoMessage = function (_Message) {
    _inherits(InfoMessage, _Message);

    function InfoMessage(text) {
        _classCallCheck(this, InfoMessage);

        return _possibleConstructorReturn(this, (InfoMessage.__proto__ || Object.getPrototypeOf(InfoMessage)).call(this, text, "info"));
    }

    return InfoMessage;
}(_Message2.Message);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WarningMessage = undefined;

var _Message2 = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WarningMessage = exports.WarningMessage = function (_Message) {
    _inherits(WarningMessage, _Message);

    function WarningMessage(text) {
        _classCallCheck(this, WarningMessage);

        return _possibleConstructorReturn(this, (WarningMessage.__proto__ || Object.getPrototypeOf(WarningMessage)).call(this, text, "warning"));
    }

    return WarningMessage;
}(_Message2.Message);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PreferenceManager = PreferenceManager;

var _PreferencesUtilities = __webpack_require__(4);

var _Preference = __webpack_require__(3);

var _PreferenceWithValue = __webpack_require__(26);

function PreferenceManager(preferencesData) {
    var LOCALSTORAGE_PREFIX = "pref_key_";

    // Parse and validate preferences:
    (0, _PreferencesUtilities.log)("Validating preferences ...");
    var PREFERENCES = parsePreferences(preferencesData);
    (0, _PreferencesUtilities.log)("Done.");

    // Initialize cached preference database:
    var CACHED_PREFERENCES_WITH_VALUES = getAllPreferencesWithDefaultValues();
    CACHED_PREFERENCES_WITH_VALUES.forEach(function (preferenceWithValue) {
        var key = preferenceWithValue.preference.key;
        var defaultValue = preferenceWithValue.preference.getDefaultValue();
        try {
            var savedValue = getSaved(key);
            if (savedValue === null) {
                (0, _PreferencesUtilities.log)("Using default value '" + defaultValue + "' for preference '" + key + "' since there was no saved value.");
            }
            preferenceWithValue.value = savedValue !== null ? savedValue : defaultValue;
        } catch (e) {
            if (e instanceof TypeError) {
                (0, _PreferencesUtilities.logWarning)("Using default value '" + defaultValue + "' for preference '" + key + "' since the saved value in localStorage was not a valid one.");
            } else {
                (0, _PreferencesUtilities.logWarning)("Using default value '" + defaultValue + "' for preference '" + key + "' since no saved value could be loaded from localStorage.");
            }
        }
    });

    function parsePreferences(preferencesData) {
        return preferencesData.map(parsePreference);
    }

    function parsePreference(pref, index) {
        if (!(0, _PreferencesUtilities.isString)(pref.key)) {
            throw new TypeError("'The preference at index " + index + " does not have a valid key (found " + pref.key + ").");
        } else if (pref.type === undefined || !(pref.type.prototype instanceof _Preference.Preference)) {
            throw new TypeError("Preference '" + pref.key + "' does not use a valid preference type (found " + pref.type + ").");
        } else if (pref.default === undefined) {
            throw new TypeError("Preference '" + pref.key + "' has no default value.");
        }
        return new pref.type(pref);
    }

    function preferenceExists(key) {
        return getPreference(key) !== undefined;
    }

    function getPreference(key) {
        return PREFERENCES.find(function (pref) {
            return pref.key === key;
        });
    }

    function getCachedPreference(key) {
        return CACHED_PREFERENCES_WITH_VALUES.find(function (preferenceWithValue) {
            return preferenceWithValue.preference.key === key;
        });
    }

    function getAllPreferencesWithValues_saved() {
        // throws SecurityError etc
        return PREFERENCES.map(function (preference) {
            return new _PreferenceWithValue.PreferenceWithValue(preference, getSaved(preference.key));
        });
    }

    function getAllPreferencesWithValues_cached() {
        return PREFERENCES.map(function (preference) {
            return new _PreferenceWithValue.PreferenceWithValue(preference, getCached(preference.key));
        });
    }

    function getAllPreferencesWithDefaultValues() {
        return PREFERENCES.map(function (preference) {
            return new _PreferenceWithValue.PreferenceWithValue(preference, preference.getDefaultValue());
        });
    }

    function getKey(pref) {
        return pref.key;
    }

    function isValidPreferenceValue(key, value) {
        return getPreference(key).isValidValue(value);
    }

    function setToDefaultValue(key) {
        // throws SecurityError etc
        set(key, getDefaultValue(key));
    }

    function getDefaultValue(key) {
        if (!preferenceExists(key)) {
            throw new Error("Preference '" + key + "' does not exist.");
        }
        return getPreference(key).getDefaultValue();
    }

    function LS_prefix(key) {
        return LOCALSTORAGE_PREFIX + key;
    }

    function set(key, value) {
        // throws SecurityError etc
        if (!preferenceExists(key)) {
            throw new Error("There is no preference with key '" + key + "'.");
        }
        var pref = getPreference(key);
        if (!isValidPreferenceValue(key, value)) {
            pref.invalidValue(value);
        } else {
            (0, _PreferencesUtilities.log)("Setting preference '" + key + "' to '" + value + "'.");
            getCachedPreference(key).value = value;
            try {
                localStorage.setItem(LS_prefix(key), pref.constructor.stringify(value));
            } catch (e) {
                (0, _PreferencesUtilities.logError)("Failed to save value for preference '" + key + "' to localStorage. The following error was thrown:\n" + e);
                throw e; // likely a SecurityError, but could be others as well
            }
        }
    }

    function getSaved(key) {
        // throws SecurityError, TypeError etc
        if (!preferenceExists(key)) {
            throw new Error("There is no preference with key '" + key + "'.");
        }
        var pref = getPreference(key);
        var savedValue = void 0;
        try {
            savedValue = localStorage.getItem(LS_prefix(key));
        } catch (e) {
            (0, _PreferencesUtilities.logError)("Failed to load saved value for preference '" + key + "' from localStorage. The following error was thrown:\n" + e);
            throw e; // likely a SecurityError, but could be others as well
        }
        if (savedValue === null) {
            // There was no saved value.
            return null;
        } else if (isValidPreferenceValue(key, pref.constructor.parse(savedValue))) {
            return pref.constructor.parse(savedValue);
        } else {
            throw new TypeError("'" + savedValue + "' could not be parsed to a valid value for preference '" + pref + "'.");
        }
    }

    function getCached(key) {
        if (!preferenceExists(key)) {
            throw new Error("There is no preference with key '" + key + "'.");
        }
        return getCachedPreference(key).value;
    }

    function setAllToDefault() {
        (0, _PreferencesUtilities.log)("Resetting all preferences ...");
        PREFERENCES.map(getKey).forEach(setToDefaultValue);
        (0, _PreferencesUtilities.log)("Done.");
    }

    return {
        isValidPreferenceValue: isValidPreferenceValue,
        set: set,
        getSaved: getSaved,
        getCached: getCached,
        setToDefaultValue: setToDefaultValue,
        getDefaultValue: getDefaultValue,
        getAllPreferencesWithValues_saved: getAllPreferencesWithValues_saved,
        getAllPreferencesWithValues_cached: getAllPreferencesWithValues_cached,
        getAllPreferencesWithDefaultValues: getAllPreferencesWithDefaultValues,
        setAllToDefault: setAllToDefault
    };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BooleanPreference = __webpack_require__(9);

var _MultichoicePreference = __webpack_require__(10);

var _ZatackaEn_US = __webpack_require__(1);

var _ZatackaEn_US2 = _interopRequireDefault(_ZatackaEn_US);

var _strings = __webpack_require__(2);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Object.freeze([{
    type: _BooleanPreference.BooleanPreference,
    key: _strings2.default.pref_key_prevent_spawnkill,
    label: _ZatackaEn_US2.default.pref_label_prevent_spawnkill,
    description: _ZatackaEn_US2.default.pref_label_description_prevent_spawnkill,
    default: false
}, {
    type: _BooleanPreference.BooleanPreference,
    key: _strings2.default.pref_key_confirm_quit,
    label: _ZatackaEn_US2.default.pref_label_confirm_quit,
    description: _ZatackaEn_US2.default.pref_label_description_confirm_quit,
    default: true
}, {
    type: _MultichoicePreference.MultichoicePreference,
    key: _strings2.default.pref_key_scaling,
    label: _ZatackaEn_US2.default.pref_label_scaling,
    description: _ZatackaEn_US2.default.pref_label_description_scaling,
    options: [{
        key: _strings2.default.pref_value_scaling_prefer_quality,
        label: _ZatackaEn_US2.default.pref_label_scaling_prefer_quality
    }, {
        key: _strings2.default.pref_value_scaling_prefer_size,
        label: _ZatackaEn_US2.default.pref_label_scaling_prefer_size
    }],
    default: _strings2.default.pref_value_scaling_prefer_quality
}, {
    type: _MultichoicePreference.MultichoicePreference,
    key: _strings2.default.pref_key_cursor,
    label: _ZatackaEn_US2.default.pref_label_cursor,
    description: _ZatackaEn_US2.default.pref_label_description_cursor,
    options: [{
        key: _strings2.default.pref_value_cursor_always_visible,
        label: _ZatackaEn_US2.default.pref_label_cursor_always_visible
    }, {
        key: _strings2.default.pref_value_cursor_hidden_when_mouse_used_by_player,
        label: _ZatackaEn_US2.default.pref_label_cursor_hidden_when_mouse_used_by_player
    }, {
        key: _strings2.default.pref_value_cursor_always_hidden,
        label: _ZatackaEn_US2.default.pref_label_cursor_always_hidden
    }],
    default: _strings2.default.pref_value_cursor_hidden_when_mouse_used_by_player
}, {
    type: _MultichoicePreference.MultichoicePreference,
    key: _strings2.default.pref_key_edge_fix,
    label: _ZatackaEn_US2.default.pref_label_edge_fix,
    description: _ZatackaEn_US2.default.pref_label_description_edge_fix,
    options: [{
        key: _strings2.default.pref_value_edge_fix_off,
        label: _ZatackaEn_US2.default.pref_label_edge_fix_off
    }, {
        key: _strings2.default.pref_value_edge_fix_minimal,
        label: _ZatackaEn_US2.default.pref_label_edge_fix_minimal
    }, {
        key: _strings2.default.pref_value_edge_fix_full,
        label: _ZatackaEn_US2.default.pref_label_edge_fix_full
    }],
    default: _strings2.default.pref_value_edge_fix_off
}, {
    type: _MultichoicePreference.MultichoicePreference,
    key: _strings2.default.pref_key_hints,
    label: _ZatackaEn_US2.default.pref_label_hints,
    description: _ZatackaEn_US2.default.pref_label_description_hints,
    options: [{
        key: _strings2.default.pref_value_hints_all,
        label: _ZatackaEn_US2.default.pref_label_hints_all
    }, {
        key: _strings2.default.pref_value_hints_warnings_only,
        label: _ZatackaEn_US2.default.pref_label_hints_warnings_only
    }, {
        key: _strings2.default.pref_value_hints_none,
        label: _ZatackaEn_US2.default.pref_label_hints_none
    }],
    default: _strings2.default.pref_value_hints_all
}]);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _utilities = __webpack_require__(0);

var _Game = __webpack_require__(13);

var _Player = __webpack_require__(5);

var _Renderer = __webpack_require__(14);

var _GUIController = __webpack_require__(12);

var _preferences = __webpack_require__(18);

var _preferences2 = _interopRequireDefault(_preferences);

var _PreferenceManager = __webpack_require__(17);

var _InfoMessage = __webpack_require__(15);

var _WarningMessage = __webpack_require__(16);

var _ConfirmationDialog = __webpack_require__(6);

var _ZatackaEn_US = __webpack_require__(1);

var _ZatackaEn_US2 = _interopRequireDefault(_ZatackaEn_US);

var _strings = __webpack_require__(2);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Zatacka = function () {

    var canvas_main = (0, _utilities.byID)("canvas_main");
    var canvas_overlay = (0, _utilities.byID)("canvas_overlay");
    var ORIGINAL_WIDTH = canvas_main.width;
    var ORIGINAL_HEIGHT = canvas_main.height;
    var TOTAL_BORDER_THICKNESS = 4;
    var KEY_RELOAD = _utilities.KEY.F5;
    var KEY_FULLSCREEN = _utilities.KEY.F11;
    var KEY_DEVTOOLS = _utilities.KEY.F12;
    var ALLOWED_KEYS = [KEY_FULLSCREEN, KEY_DEVTOOLS]; // not to be intercepted by our event handler

    var config = Object.freeze({
        tickrate: 600, // Hz
        maxFramerate: 300, // Hz
        canvas: canvas_main,
        thickness: 3, // Kuxels
        speed: 60, // Kuxels per second
        turningRadius: 28.5, // Kuxels (NB: _radius_)
        minSpawnAngle: -Math.PI / 2, // radians
        maxSpawnAngle: Math.PI / 2, // radians
        spawnMargin: 100, // Kuxels
        preventSpawnkill: false,
        flickerFrequency: 20, // Hz, when spawning
        flickerDuration: 830, // ms, when spawning
        minHoleInterval: 90, // Kuxels
        maxHoleInterval: 300, // Kuxels
        minHoleSize: 5, // Kuxels
        maxHoleSize: 9, // Kuxels
        hintDelay: 3000, // ms
        keys: {
            "proceed": [_utilities.KEY.SPACE, _utilities.KEY.ENTER],
            "quit": [_utilities.KEY.ESCAPE]
        },
        messages: Object.freeze({
            pick: new _InfoMessage.InfoMessage(_ZatackaEn_US2.default.hint_pick),
            proceed: new _InfoMessage.InfoMessage(_ZatackaEn_US2.default.hint_proceed),
            next: new _InfoMessage.InfoMessage(_ZatackaEn_US2.default.hint_next),
            quit: new _InfoMessage.InfoMessage(_ZatackaEn_US2.default.hint_quit),
            popup: new _WarningMessage.WarningMessage("<a href=\"" + _strings2.default.game_url + "\" target=\"_blank\">" + _ZatackaEn_US2.default.hint_popup + "</a>"),
            alt: new _WarningMessage.WarningMessage(_ZatackaEn_US2.default.hint_alt),
            ctrl: new _WarningMessage.WarningMessage(_ZatackaEn_US2.default.hint_ctrl),
            mouse: new _WarningMessage.WarningMessage(_ZatackaEn_US2.default.hint_mouse),
            preferences_access_denied: new _WarningMessage.WarningMessage(_ZatackaEn_US2.default.hint_preferences_access_denied)
        }),
        dialogs: Object.freeze({
            confirmation_quit: new _ConfirmationDialog.ConfirmationDialog(_ZatackaEn_US2.default.label_text_confirm_quit, quitGame),
            confirmation_reload: new _ConfirmationDialog.ConfirmationDialog(_ZatackaEn_US2.default.label_text_confirm_reload, reload)
        }),
        defaultPlayers: Object.freeze([{ id: 1, name: "Red", color: "#FF2800", keyL: _utilities.KEY["1"], keyR: _utilities.KEY.Q }, { id: 2, name: "Yellow", color: "#C3C300", keyL: [_utilities.KEY.CTRL, _utilities.KEY.Z], keyR: [_utilities.KEY.ALT, _utilities.KEY.X] }, { id: 3, name: "Orange", color: "#FF7900", keyL: _utilities.KEY.M, keyR: _utilities.KEY.COMMA }, { id: 4, name: "Green", color: "#00CB00", keyL: _utilities.KEY.LEFT_ARROW, keyR: _utilities.KEY.DOWN_ARROW }, { id: 5, name: "Pink", color: "#DF51B6", keyL: [_utilities.KEY.DIVIDE, _utilities.KEY.END, _utilities.KEY.PAGE_DOWN], keyR: [_utilities.KEY.MULTIPLY, _utilities.KEY.PAGE_UP] }, { id: 6, name: "Blue", color: "#00A2CB", keyL: _utilities.MOUSE.LEFT, keyR: _utilities.MOUSE.RIGHT }])
    });

    var preferenceManager = new _PreferenceManager.PreferenceManager(_preferences2.default);

    function isProceedKey(key) {
        return config.keys.proceed.includes(key);
    }

    function isQuitKey(key) {
        return config.keys.quit.includes(key);
    }

    function shouldPreventDefault(key) {
        return !ALLOWED_KEYS.includes(key);
    }

    function setEdgePadding(padding) {
        if (game.isStarted()) {
            throw new Error("Cannot change edge padding when the game is running.");
        } else {
            var newCanvasWidth = ORIGINAL_WIDTH - padding;
            var newCanvasHeight = ORIGINAL_HEIGHT - 2 * padding;
            game.setSize(newCanvasWidth, newCanvasHeight);
            guiController.setEdgePadding(padding);
        }
    }

    function setEdgeMode(mode) {
        var padding = 0;
        if (mode === "minimal") {
            padding = 1;
        } else if (mode === "full") {
            padding = TOTAL_BORDER_THICKNESS;
        }
        try {
            setEdgePadding(padding);
        } catch (e) {
            (0, _utilities.logError)(e);
        }
    }

    function setScalingMode(mode) {
        guiController.setBlurryScaling(mode === _strings2.default.pref_value_scaling_prefer_size);
    }

    function setPreventSpawnkill(mode) {
        if (game.isStarted()) {
            throw new Error("Cannot change edge padding when the game is running.");
        } else {
            game.setPreventSpawnkill(mode);
        }
    }

    function getHoleConfig() {
        return {
            minHoleSize: config.minHoleSize,
            maxHoleSize: config.maxHoleSize,
            minHoleInterval: config.minHoleInterval,
            maxHoleInterval: config.maxHoleInterval
        };
    }

    function getPaddedHoleConfig() {
        var thickness = config.thickness;
        var holeConfig = getHoleConfig();
        var paddedHoleConfig = {};
        paddedHoleConfig.minPaddedHoleSize = holeConfig.minHoleSize + thickness;
        paddedHoleConfig.maxPaddedHoleSize = holeConfig.maxHoleSize + thickness;
        paddedHoleConfig.minPaddedHoleInterval = Math.max(0, holeConfig.minHoleInterval - thickness);
        paddedHoleConfig.maxPaddedHoleInterval = Math.max(0, holeConfig.maxHoleInterval - thickness);
        return paddedHoleConfig;
    }

    function defaultPlayerData(id) {
        return config.defaultPlayers.find(function (defaultPlayer) {
            return defaultPlayer.id === id;
        });
    }

    function defaultPlayer(id) {
        var playerData = defaultPlayerData(id);
        if (playerData === undefined) {
            throw new TypeError("There is no default player with ID " + id + ".");
        }
        return new _Player.Player(playerData.id, playerData.name, playerData.color, playerData.keyL, playerData.keyR, getPaddedHoleConfig());
    }

    function applyCursorBehavior() {
        var mouseIsBeingUsed = game.getPlayers().some(hasMouseButton);
        var behavior = void 0;
        switch (preferenceManager.getCached(_strings2.default.pref_key_cursor)) {
            case _strings2.default.pref_value_cursor_hidden_when_mouse_used_by_player:
                behavior = mouseIsBeingUsed ? _strings2.default.cursor_hidden : _strings2.default.cursor_visible;
                break;
            case _strings2.default.pref_value_cursor_always_hidden:
                behavior = _strings2.default.cursor_hidden;
                break;
            default:
                behavior = _strings2.default.cursor_visible;
        }
        (0, _utilities.log)("Setting cursor behavior to " + behavior + ".");
        guiController.setCursorBehavior(behavior);
    }

    function proceedKeyPressedInLobby() {
        var numberOfReadyPlayers = game.getNumberOfPlayers();
        if (numberOfReadyPlayers > 0) {
            clearMessages();
            applyCursorBehavior();
            game.setMode(numberOfReadyPlayers === 1 ? _Game.Game.PRACTICE : _Game.Game.COMPETITIVE);
            game.start();
        }
    }

    function hasMouseButton(player) {
        return player.usesAnyMouseButton();
    }

    function checkForDangerousInput() {
        if (game.getPlayers().some(function (player) {
            return player.hasKey(_utilities.KEY.CTRL);
        })) {
            guiController.showMessage(config.messages.ctrl);
        } else {
            guiController.hideMessage(config.messages.ctrl);
        }

        if (game.getPlayers().some(function (player) {
            return player.hasKey(_utilities.KEY.ALT);
        })) {
            guiController.showMessage(config.messages.alt);
        } else {
            guiController.hideMessage(config.messages.alt);
        }

        if (game.getPlayers().some(hasMouseButton)) {
            guiController.showMessage(config.messages.mouse);
        } else {
            guiController.hideMessage(config.messages.mouse);
        }
    }

    function addPlayer(id) {
        game.addPlayer(defaultPlayer(id));
        checkForDangerousInput();
        clearTimeout(hintPickTimer);
        guiController.hideMessage(config.messages.pick);
        clearTimeout(hintProceedTimer);
        hintProceedTimer = setTimeout(function () {
            guiController.showMessage(config.messages.proceed);
        }, config.hintDelay);
    }

    function removePlayer(id) {
        game.removePlayer(id);
        checkForDangerousInput();
        clearTimeout(hintProceedTimer);
        if (game.getNumberOfPlayers() === 0) {
            guiController.hideMessage(config.messages.proceed);
        } else {
            hintProceedTimer = setTimeout(function () {
                guiController.showMessage(config.messages.proceed);
            }, config.hintDelay);
        }
    }

    function defaultPlayerHasLeftKey(playerData, pressedKey) {
        return pressedKey === playerData.keyL || playerData.keyL instanceof Array && playerData.keyL.includes(pressedKey);
    }

    function defaultPlayerHasRightKey(playerData, pressedKey) {
        return pressedKey === playerData.keyR || playerData.keyR instanceof Array && playerData.keyR.includes(pressedKey);
    }

    function addOrRemovePlayer(playerData, pressedKey) {
        if (defaultPlayerHasLeftKey(playerData, pressedKey)) {
            addPlayer(playerData.id);
        } else if (defaultPlayerHasRightKey(playerData, pressedKey)) {
            removePlayer(playerData.id);
        }
    }

    function eventConsumer(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    function keyPressedInLobby(pressedKey) {
        config.defaultPlayers.forEach(function (playerData) {
            addOrRemovePlayer(playerData, pressedKey);
        });
    }

    function mouseClickedInLobby(button) {
        config.defaultPlayers.forEach(function (playerData) {
            addOrRemovePlayer(playerData, _utilities.MOUSE.pack(button));
        });
    }

    function keyHandler(event) {
        var callback = game.isStarted() ? gameKeyHandler : guiController.isShowingSettings() ? settingsKeyHandler : lobbyKeyHandler;
        guiController.keyPressed(event, callback);
    }

    function mouseHandler(event) {
        var handle = game.isStarted() ? gameMouseHandler : guiController.isShowingSettings() ? settingsMouseHandler : guiController.isShowingDialog() ? eventConsumer : event.target instanceof HTMLAnchorElement ? function () {} : lobbyMouseHandler;
        handle(event);
    }

    function unloadHandler(event) {
        if (game.isStarted()) {
            gameUnloadHandler(event);
        }
    }

    function lobbyKeyHandler(event) {
        if (shouldPreventDefault(event.keyCode)) {
            event.preventDefault();
        }
        var pressedKey = event.keyCode;
        if (pressedKey === KEY_RELOAD) {
            reload();
        } else if (isProceedKey(pressedKey)) {
            proceedKeyPressedInLobby();
        } else {
            keyPressedInLobby(pressedKey);
        }
    }

    function lobbyMouseHandler(event) {
        mouseClickedInLobby(event.button);
    }

    function reload() {
        window.removeEventListener("beforeunload", unloadHandler);
        window.location.reload();
    }

    function quitGame() {
        game.quit();
        guiController.gameQuit();
        game = newGame();
        applySettings();
    }

    function gameKeyHandler(event) {
        if (shouldPreventDefault(event.keyCode)) {
            event.preventDefault();
        }
        var pressedKey = event.keyCode;
        if (isProceedKey(pressedKey)) {
            if (game.isPaused()) {
                game.resume();
            } else if (game.shouldQuitOnProceedKey()) {
                quitGame();
            } else {
                game.proceedKeyPressed();
            }
        } else if (isQuitKey(pressedKey) && game.shouldQuitOnQuitKey()) {
            if (preferenceManager.getCached(_strings2.default.pref_key_confirm_quit) === true && !guiController.isShowingDialog()) {
                guiController.showDialog(config.dialogs.confirmation_quit);
            } else {
                quitGame();
            }
        } else if (pressedKey === KEY_RELOAD) {
            if (preferenceManager.getCached(_strings2.default.pref_key_confirm_quit) === true) {
                if (game.shouldShowReloadConfirmationOnReloadKey() && !guiController.isShowingDialog()) {
                    guiController.showDialog(config.dialogs.confirmation_reload, reload);
                }
            } else {
                reload();
            }
        }
    }

    function gameMouseHandler(event) {
        event.preventDefault();
    }

    function gameUnloadHandler(event) {
        // A simple trick to prevent accidental unloading of the entire game.
        return event.returnValue = true;
    }

    function settingsKeyHandler(event) {
        var pressedKey = event.keyCode;
        if (isQuitKey(pressedKey)) {
            hideSettings();
        } else if (pressedKey === KEY_RELOAD) {
            reload();
        }
    }

    function settingsMouseHandler(event) {
        // Intentionally empty.
    }

    function showSettings() {
        clearTimeout(hintPickTimer);
        clearTimeout(hintProceedTimer);
        try {
            guiController.updateSettingsForm(preferenceManager.getAllPreferencesWithValues_saved());
        } catch (e) {
            (0, _utilities.logWarning)("Could not load settings from localStorage. Using cached settings instead.");
            guiController.updateSettingsForm(preferenceManager.getAllPreferencesWithValues_cached());
            handleSettingsAccessError(e);
        }
        guiController.showSettings();
    }

    function hideSettings() {
        guiController.parseSettingsForm().forEach(function (newSetting) {
            try {
                preferenceManager.set(newSetting.key, newSetting.value);
            } catch (e) {
                (0, _utilities.logWarning)("Could not save setting '" + newSetting.key + "' to localStorage.");
                handleSettingsAccessError(e);
            }
        });
        applySettings();
        guiController.hideSettings();
    }

    function applySettings() {
        var preference_value_edge_fix = void 0;
        var preference_value_hints = void 0;
        var preference_value_prevent_spawnkill = void 0;
        var preference_value_scaling = void 0;
        try {
            preference_value_edge_fix = preferenceManager.getSaved(_strings2.default.pref_key_edge_fix);
            preference_value_hints = preferenceManager.getSaved(_strings2.default.pref_key_hints);
            preference_value_prevent_spawnkill = preferenceManager.getSaved(_strings2.default.pref_key_prevent_spawnkill);
            preference_value_scaling = preferenceManager.getSaved(_strings2.default.pref_key_scaling);
        } catch (e) {
            (0, _utilities.logWarning)("Could not load settings from localStorage. Using cached settings instead.");
            preference_value_edge_fix = preferenceManager.getCached(_strings2.default.pref_key_edge_fix);
            preference_value_hints = preferenceManager.getCached(_strings2.default.pref_key_hints);
            preference_value_prevent_spawnkill = preferenceManager.getCached(_strings2.default.pref_key_prevent_spawnkill);
            preference_value_scaling = preferenceManager.getCached(_strings2.default.pref_key_scaling);
            handleSettingsAccessError(e);
        }

        // Edge fix:
        setEdgeMode(preference_value_edge_fix);
        // Hints:
        guiController.setMessageMode(preference_value_hints);
        // Prevent spawnkill:
        game.setPreventSpawnkill(preference_value_prevent_spawnkill);
        // Blurry scaling:
        setScalingMode(preference_value_scaling);
    }

    function handleSettingsAccessError(error) {
        if (error.name === _strings2.default.error_name_security) {
            guiController.showMessage(config.messages.preferences_access_denied);
        }
    }

    function clearMessages() {
        clearTimeout(hintPickTimer);
        clearTimeout(hintProceedTimer);
        guiController.clearMessages();
    }

    function blurHandler() {
        (0, _utilities.logWarning)("Application lost focus.");
        if (game.isLive()) {
            game.pause();
        }
        _utilities.Keyboard.reset();
        _utilities.Mouse.reset();
    }

    function addShowSettingsButtonEventListener() {
        var showSettingsButton = (0, _utilities.byID)(_strings2.default.id_button_show_settings);
        if (showSettingsButton instanceof HTMLElement) {
            showSettingsButton.addEventListener("mousedown", eventConsumer);
            showSettingsButton.addEventListener("click", showSettings);
        }
    }

    function addHideSettingsButtonEventListener() {
        var hideSettingsButton = (0, _utilities.byID)(_strings2.default.id_button_hide_settings);
        if (hideSettingsButton instanceof HTMLElement) {
            hideSettingsButton.addEventListener("mousedown", eventConsumer);
            hideSettingsButton.addEventListener("click", hideSettings);
        }
    }

    function handleHistoryHazards() {
        if (history && history.length > 1) {
            guiController.showMessage(config.messages.popup);
        }
    }

    function addEventListeners() {
        (0, _utilities.log)("Adding event listeners ...");

        // Hide/show settings:
        addShowSettingsButtonEventListener();
        addHideSettingsButtonEventListener();

        // General event handlers:
        document.addEventListener("keydown", keyHandler);
        document.addEventListener("mousedown", mouseHandler);
        document.addEventListener("contextmenu", eventConsumer);
        window.addEventListener("beforeunload", unloadHandler);
        window.addEventListener("blur", blurHandler);

        // Player input:
        document.addEventListener("keydown", _utilities.Keyboard.onKeydown.bind(_utilities.Keyboard));
        document.addEventListener("keyup", _utilities.Keyboard.onKeyup.bind(_utilities.Keyboard));
        document.addEventListener("mousedown", _utilities.Mouse.onMousedown.bind(_utilities.Mouse));
        document.addEventListener("mouseup", _utilities.Mouse.onMouseup.bind(_utilities.Mouse));

        (0, _utilities.log)("Done.");
    }

    addEventListeners();

    function newGame() {
        return new _Game.Game(config, (0, _Renderer.Renderer)(canvas_main, canvas_overlay), guiController);
    }

    var guiController = (0, _GUIController.GUIController)(config);
    var game = newGame();

    var hintProceedTimer = void 0;
    var hintPickTimer = setTimeout(function () {
        guiController.showMessage(config.messages.pick);
    }, config.hintDelay);

    applySettings();
    handleHistoryHazards();

    return {
        getConfig: function getConfig() {
            return config;
        },
        getGame: function getGame() {
            return game;
        },
        addPlayer: function addPlayer(playerOrID) {
            var player = _Player.Player.isPlayer(playerOrID) ? playerOrID : new _Player.Player(playerOrID);
            game.addPlayer(player);
        }
    };
}();

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Round = exports.Round = function () {
    function Round(players) {
        _classCallCheck(this, Round);

        // A list of the players in the order they died (winner also included):
        this.results = [];
    }

    _createClass(Round, [{
        key: "add",
        value: function add(player) {
            this.results.push(player);
        }
    }, {
        key: "getSuccessOfPlayer",
        value: function getSuccessOfPlayer(id) {
            for (var i = 0; i < this.results.length; i++) {
                if (this.results[i].hasID(id)) {
                    return i;
                }
            }
            return this.results.length;
        }
    }, {
        key: "getResults",
        value: function getResults() {
            return this.results;
        }
    }]);

    return Round;
}();

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = Queue;
//code.stephenmorley.org
function Queue() {
  var a = [],
      b = 0;this.getLength = function () {
    return a.length - b;
  };this.hasItem = function (i) {
    return a.indexOf(i) !== -1;
  };this.isEmpty = function () {
    return 0 === a.length;
  };this.enqueue = function (b) {
    a.push(b);
  };this.dequeue = function () {
    if (0 !== a.length) {
      var c = a[b];2 * ++b >= a.length && (a = a.slice(b), b = 0);return c;
    }
  };this.peek = function () {
    return 0 < a.length ? a[b] : void 0;
  };
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * mainloop.js 1.0.1-20150816
 *
 * @author Isaac Sukin (http://www.isaacsukin.com/)
 * @license MIT
 */

exports.default = !function (a) {
  function b(a) {
    if (e + j > a) return u = n(b), void 0;for (d += a - e, e = a, q(a, d), a > g + 1e3 && (f = .25 * h + .75 * f, g = a, h = 0), h++, i = 0; d >= c;) {
      if (r(c), d -= c, ++i >= 240) {
        m = !0;break;
      }
    }s(d / c), t(f, m), m = !1, u = n(b);
  }var c = 1e3 / 60,
      d = 0,
      e = 0,
      f = 60,
      g = 0,
      h = 0,
      i = 0,
      j = 0,
      k = !1,
      l = !1,
      m = !1,
      n = a.requestAnimationFrame || function () {
    var a = Date.now(),
        b,
        d;return function (e) {
      return b = Date.now(), d = Math.max(0, c - (b - a)), a = b + d, setTimeout(function () {
        e(b + d);
      }, d);
    };
  }(),
      o = a.cancelAnimationFrame || clearTimeout,
      p = function p() {},
      q = p,
      r = p,
      s = p,
      t = p,
      u;a.MainLoop = { getSimulationTimestep: function getSimulationTimestep() {
      return c;
    }, setSimulationTimestep: function setSimulationTimestep(a) {
      return c = a, this;
    }, getFPS: function getFPS() {
      return f;
    }, getMaxAllowedFPS: function getMaxAllowedFPS() {
      return 1e3 / j;
    }, setMaxAllowedFPS: function setMaxAllowedFPS(a) {
      return "undefined" == typeof a && (a = 1 / 0), 0 === a ? this.stop() : j = 1e3 / a, this;
    }, resetFrameDelta: function resetFrameDelta() {
      var a = d;return d = 0, a;
    }, setBegin: function setBegin(a) {
      return q = a || q, this;
    }, setUpdate: function setUpdate(a) {
      return r = a || r, this;
    }, setDraw: function setDraw(a) {
      return s = a || s, this;
    }, setEnd: function setEnd(a) {
      return t = a || t, this;
    }, start: function start() {
      return l || (l = !0, u = n(function (a) {
        s(1), k = !0, e = a, g = a, h = 0, u = n(b);
      })), this;
    }, stop: function stop() {
      return k = !1, l = !1, o(u), this;
    }, isRunning: function isRunning() {
      return k;
    } },  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a.MainLoop),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && (module.exports = a.MainLoop);
}(window);
//# sourceMappingURL=mainloop.min.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IntegerRangePreference = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Preference = __webpack_require__(3);

var _RangePreference2 = __webpack_require__(11);

var _PreferencesUtilities = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegerRangePreference = exports.IntegerRangePreference = function (_RangePreference) {
    _inherits(IntegerRangePreference, _RangePreference);

    function IntegerRangePreference(data) {
        _classCallCheck(this, IntegerRangePreference);

        if (!(0, _PreferencesUtilities.isInt)(data.min) || !(0, _PreferencesUtilities.isInt)(data.max)) {
            throw new TypeError("min and max must be integers (found " + data.min + " and " + data.max + " for preference '" + data.key + "').");
        }

        var _this = _possibleConstructorReturn(this, (IntegerRangePreference.__proto__ || Object.getPrototypeOf(IntegerRangePreference)).call(this, data));

        _this.min = data.min;
        _this.max = data.max;
        if (!_this.isValidValue(data.default)) {
            _get(IntegerRangePreference.prototype.__proto__ || Object.getPrototypeOf(IntegerRangePreference.prototype), "invalidValue", _this).call(_this, data.default);
        }
        return _this;
    }

    _createClass(IntegerRangePreference, [{
        key: "isValidValue",
        value: function isValidValue(value) {
            return (0, _PreferencesUtilities.isInt)(value) && value >= this.min && value <= this.max;
        }
    }], [{
        key: "stringify",
        value: function stringify(value) {
            return value.toString();
        }
    }, {
        key: "parse",
        value: function parse(stringifiedValue) {
            return parseInt(stringifiedValue);
        }
    }]);

    return IntegerRangePreference;
}(_RangePreference2.RangePreference);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultichoicePreferenceOption = undefined;

var _PreferencesUtilities = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MultichoicePreferenceOption = exports.MultichoicePreferenceOption = function MultichoicePreferenceOption(key, label) {
    _classCallCheck(this, MultichoicePreferenceOption);

    var CLASS_MULTICHOICE_PREFERENCE = "MultichoicePreference";
    if (!isValidKey(key)) {
        throw new TypeError("The key of a " + CLASS_MULTICHOICE_PREFERENCE + " option must be a non-empty string (found " + key + ").");
    }
    if (!isValidLabel(label)) {
        throw new TypeError("The label of a " + CLASS_MULTICHOICE_PREFERENCE + " option must be a string (found " + label + " for option '" + key + "').");
    }

    this.key = key;
    this.label = label;

    function isValidKey(key) {
        return (0, _PreferencesUtilities.isNonEmptyString)(key);
    }

    function isValidLabel(label) {
        return (0, _PreferencesUtilities.isString)(label);
    }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreferenceWithValue = exports.PreferenceWithValue = function PreferenceWithValue(preference, value) {
    _classCallCheck(this, PreferenceWithValue);

    if (!preference.isValidValue(value)) {
        throw new TypeError(value + " is not a valid value for preference " + preference.key + ".");
    }
    this.preference = preference;
    this.value = value;
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// zatacka.min.js